import AtomInfo from "./types/AtomInfo";

const data: AtomInfo[] = [
  {
    name: "Accelerometer",
    appearance: "colorless gas",
    atomicMass: 1.008,
    boil: 20.271,
    category: "Hardware",
    color: null,
    density: 0.08988,
    discoveredBy: "Henry Cavendish",
    melt: 13.99,
    molarHeat: 28.836,

    number: 1,
    period: 1,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Hydrogen",

    summary:
      "An accelerometer is an electronic device that can measure the position of the vehicle (up/down, left/right, and forward/backward). Information from the accelerometer is used in collision reconstruction to understand driving behavior leading up to the event. Learn more about telematics hardware technology in this article.",
    symbol: "Ac",
    group: 1,

    shells: [1],
    electronAffinity: 72.769,
    electronegativityPauling: 2.2,
    ionizationEnergies: [1312],
    earthAbundance: 1400,
  },
  {
    name: "Duty of Care",
    appearance:
      "colorless gas, exhibiting a red-orange glow when placed in a high-voltage electric field",
    atomicMass: 4.0026022,
    boil: 4.222,
    category: "Compliance",
    color: null,
    density: 0.1786,
    discoveredBy: "Pierre Janssen",
    melt: 0.95,
    molarHeat: null,

    number: 2,
    period: 1,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Helium",

    summary:
      "Duty of care is the responsibility of fleet managers to help keep drivers safe and healthy, through measures for assessing and reducing risk.",
    symbol: "Du",
    group: 18,

    shells: [2],

    electronAffinity: -48,
    electronegativityPauling: null,
    ionizationEnergies: [2372.3, 5250.5],
    earthAbundance: 0.008,
  },
  {
    name: "GO Device",
    appearance: "silvery-white",
    atomicMass: 6.94,
    boil: 1603,
    category: "Hardware",
    color: null,
    density: 0.534,
    discoveredBy: "Johan August Arfwedson",
    melt: 453.65,
    molarHeat: 24.86,

    number: 3,
    period: 2,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Lithium",

    summary:
      "The Geotab GO is a proprietary telematics device for fleet management with state-of-the-art GPS technology, G-force monitoring, GEOTAB IOX expandability, and engine and battery health assessments, with data security measures.",
    symbol: "Gd",
    group: 1,

    shells: [2, 1],

    electronAffinity: 59.6326,
    electronegativityPauling: 0.98,
    ionizationEnergies: [520.2, 7298.1, 11815],
    earthAbundance: 20,
  },
  {
    name: "Firmware",
    appearance: "white-gray metallic",
    atomicMass: 9.01218315,
    boil: 2742,
    category: "Software",
    color: null,
    density: 1.85,
    discoveredBy: "Louis Nicolas Vauquelin",
    melt: 1560,
    molarHeat: 16.443,

    number: 4,
    period: 2,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Beryllium",

    summary:
      "Firmware is a specific type of software and that is designed to work closely with hardware, instead of abstracting it away behind an operating system. Many devices running firmware run either a very simple OS or none at all. This allows for greater control of hardware at the cost of increased complexity in implementation.",
    symbol: "Fw",
    group: 2,

    shells: [2, 2],

    electronAffinity: -48,
    electronegativityPauling: 1.57,
    ionizationEnergies: [899.5, 1757.1, 14848.7, 21006.6],
    earthAbundance: 2.8,
  },
  {
    name: "Asset Tracking",
    appearance: "black-brown",
    atomicMass: 10.81,
    boil: 4200,
    category: "Productivity",
    color: null,
    density: 2.08,
    discoveredBy: "Joseph Louis Gay-Lussac",
    melt: 2349,
    molarHeat: 11.087,

    number: 5,
    period: 2,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Boron",

    summary:
      "Beyond the vehicle, companies have many other types of assets, such as heavy machinery, equipment, tools, etc. All of these can be tracked like a vehicle. Using Bluetooth® technology, the location of assets can be shown on a map, geofences setup to reduce theft, alerts when an asset reaches a certain location, and so on.",
    symbol: "As",
    group: 13,

    shells: [2, 3],

    electronAffinity: 26.989,
    electronegativityPauling: 2.04,
    ionizationEnergies: [800.6, 2427.1, 3659.7, 25025.8, 32826.7],
    earthAbundance: 10,
  },
  {
    name: "Asset Utilization",
    appearance: null,
    atomicMass: 12.011,
    boil: null,
    category: "Fleet Optimization",
    color: null,
    density: 1.821,
    discoveredBy: "Ancient Egypt",
    melt: null,
    molarHeat: 8.517,

    number: 6,
    period: 2,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Carbon",

    summary:
      "Fleet asset utilization is the understanding of what vehicles are in your fleet, who is driving them, where they are going, when they are arriving, and how they will get there. By tracking these details, fleets managers can get a better picture of fleet performance and how to use each vehicle, driver and route to the company’s advantage.",
    symbol: "Au",
    group: 14,

    shells: [2, 4],

    electronAffinity: 121.7763,
    electronegativityPauling: 2.55,
    ionizationEnergies: [1086.5, 2352.6, 4620.5, 6222.7, 37831, 47277],
    earthAbundance: 200,
  },
  {
    name: "Benchmarking",
    appearance: "colorless gas, liquid or solid",
    atomicMass: 14.007,
    boil: 77.355,
    category: "Fleet Optimization",
    color: null,
    density: 1.251,
    discoveredBy: "Daniel Rutherford",
    melt: 63.15,
    molarHeat: null,

    number: 7,
    period: 2,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Nitrogen",

    summary:
      "Benchmarking is a trusted strategy for evaluating and improving operations based on a fleet’s driving patterns. It measures the current performance, and tracks progress towards goals. With telematics, users are able to gather a large volume and variety of data, set unique fleet goals and make necessary adjustments.",
    symbol: "Bm",
    group: 15,

    shells: [2, 5],

    electronAffinity: -6.8,
    electronegativityPauling: 3.04,
    ionizationEnergies: [1402.3, 2856, 4578.1, 7475, 9444.9, 53266.6, 64360],
    earthAbundance: 19,
  },
  {
    name: "COI",
    appearance: null,
    atomicMass: 15.999,
    boil: 90.188,
    category: "Fleet Optimization",
    color: null,
    density: 1.429,
    discoveredBy: "Carl Wilhelm Scheele",
    melt: 54.36,
    molarHeat: null,

    number: 8,
    period: 2,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Oxygen",

    summary:
      "As opposed to return on investment (ROI), the cost of ignoring (COI) is the loss of savings that occur by not taking a specific action.",
    symbol: "Ci",
    group: 16,

    shells: [2, 6],

    electronAffinity: 140.976,
    electronegativityPauling: 3.44,
    ionizationEnergies: [
      1313.9,
      3388.3,
      5300.5,
      7469.2,
      10989.5,
      13326.5,
      71330,
      84078,
    ],
    earthAbundance: 461000,
  },
  {
    name: "Engine Diagnostics",
    appearance: null,
    atomicMass: 18.9984031636,
    boil: 85.03,
    category: "Fleet Optimization",
    color: null,
    density: 1.696,
    discoveredBy: "André-Marie Ampère",
    melt: 53.48,
    molarHeat: null,

    number: 9,
    period: 2,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Fluorine",

    summary:
      "Engine status data for all major engine protocols, such as rpm, voltage, fuel usage, coolant temperature, and fluid levels, can be communicated through the Geotab telematics device which plugs into the OBD II port. These on-board engine diagnostics come in the form of diagnostic trouble codes (DTCs) that can be specific to an OEM.",
    symbol: "Ed",
    group: 17,

    shells: [2, 7],

    electronAffinity: 328.1649,
    electronegativityPauling: 3.98,
    ionizationEnergies: [
      1681,
      3374.2,
      6050.4,
      8407.7,
      11022.7,
      15164.1,
      17868,
      92038.1,
      106434.3,
    ],
    earthAbundance: 585,
  },
  {
    name: "DVIR",
    appearance:
      "colorless gas exhibiting an orange-red glow when placed in a high voltage electric field",
    atomicMass: 20.17976,
    boil: 27.104,
    category: "Compliance",
    color: null,
    density: 0.9002,
    discoveredBy: "Morris Travers",
    melt: 24.56,
    molarHeat: null,

    number: 10,
    period: 2,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Neon",

    summary:
      "A driver vehicle inspection report or DVIR, is a formal record confirming that a driver has completed an inspection on a commercial motor vehicle.Inspections are carried out at the beginning of the day, before work begins, and also at the end of the day when driving is finished (called the pre-trip inspection and post-trip inspection). Vehicle inspections are an important part of a truck driver’s daily routine and they are essential to keeping vehicles in good condition, while ensuring road safety and fleet compliance.",
    symbol: "Dv",
    group: 18,

    shells: [2, 8],

    electronAffinity: -116,
    electronegativityPauling: null,
    ionizationEnergies: [
      2080.7,
      3952.3,
      6122,
      9371,
      12177,
      15238,
      19999,
      23069.5,
      115379.5,
      131432,
    ],
    earthAbundance: 0.0051,
  },
  {
    name: "GO RUGGED",
    appearance: "silvery white metallic",
    atomicMass: 22.989769282,
    boil: 1156.09,
    category: "Hardware",
    color: null,
    density: 0.968,
    discoveredBy: "Humphry Davy",
    melt: 370.944,
    molarHeat: 28.23,

    number: 11,
    period: 3,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Sodium",

    summary:
      "The GO RUGGED is a proprietary ruggedized telematics device by Geotab, designed for harsh environments and for use in off-road vehicles, mining equipment, heavy machinery and more. The protective covering on a GO RUGGED device shields the internal electronics from elements like dust and water.",
    symbol: "Gr",
    group: 1,

    shells: [2, 8, 1],

    electronAffinity: 52.867,
    electronegativityPauling: 0.93,
    ionizationEnergies: [
      495.8,
      4562,
      6910.3,
      9543,
      13354,
      16613,
      20117,
      25496,
      28932,
      141362,
      159076,
    ],
    earthAbundance: 23600,
  },
  {
    name: "Gamification",
    appearance: "shiny grey solid",
    atomicMass: 24.305,
    boil: 1363,
    category: "Software",
    color: null,
    density: 1.738,
    discoveredBy: "Joseph Black",
    melt: 923,
    molarHeat: 24.869,

    number: 12,
    period: 3,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Magnesium",

    summary:
      "Gamification is the concept of turning safe driving habits into a game or competition. Using the MyGeotab software and an integrated gamification solution, managers can see the top safest drivers and then reward good driving behavior, as well as create friendly competition among drivers.",
    symbol: "Gm",
    group: 2,

    shells: [2, 8, 2],

    electronAffinity: -40,
    electronegativityPauling: 1.31,
    ionizationEnergies: [
      737.7,
      1450.7,
      7732.7,
      10542.5,
      13630,
      18020,
      21711,
      25661,
      31653,
      35458,
      169988,
      189368,
    ],
    earthAbundance: 23300,
  },
  {
    name: "Accident Detection",
    appearance: "silvery gray metallic",
    atomicMass: 26.98153857,
    boil: 2743,
    category: "Safety",
    color: null,
    density: 2.7,
    discoveredBy: null,
    melt: 933.47,
    molarHeat: 24.2,

    number: 13,
    period: 3,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Aluminium",

    summary:
      "Accident detection occurs when the Geotab GO device detects any acceleration greater than or equal to 2.5 G, where G is 9.81 m/s2 (the acceleration due to the Earth’s gravity). This is classified as a collision-level event. When the Geotab GO device detects a 2.5 G event in any direction, the device is triggered to start recording at 100 Hz frequency. This detailed, high resolution information will be reflected in the trip in MyGeotab, and includes acceleration, GPS speed and brake data (if available.)",
    symbol: "Ad",
    group: 13,

    shells: [2, 8, 3],

    electronAffinity: 41.762,
    electronegativityPauling: 1.61,
    ionizationEnergies: [
      577.5,
      1816.7,
      2744.8,
      11577,
      14842,
      18379,
      23326,
      27465,
      31853,
      38473,
      42647,
      201266,
      222316,
    ],
    earthAbundance: 82300,
  },
  {
    name: "Dispatching",
    appearance: "crystalline, reflective with bluish-tinged faces",
    atomicMass: 28.085,
    boil: 3538,
    category: "Productivity",
    color: null,
    density: 2.329,
    discoveredBy: "Jöns Jacob Berzelius",
    melt: 1687,
    molarHeat: 19.789,

    number: 14,
    period: 3,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Silicon",

    summary:
      "Fleet dispatching is the act of directing or assigning drivers and vehicles to specific locations, or to carry out specific tasks.",
    symbol: "Di",
    group: 14,

    shells: [2, 8, 4],

    electronAffinity: 134.0684,
    electronegativityPauling: 1.9,
    ionizationEnergies: [
      786.5,
      1577.1,
      3231.6,
      4355.5,
      16091,
      19805,
      23780,
      29287,
      33878,
      38726,
      45962,
      50502,
      235196,
      257923,
    ],
    earthAbundance: 282000,
  },
  {
    name: "Engine Hours",
    appearance: "colourless, waxy white, yellow, scarlet, red, violet, black",
    atomicMass: 30.9737619985,
    boil: null,
    category: "Fleet Optimization",
    color: null,
    density: 1.823,
    discoveredBy: "Hennig Brand",
    melt: null,
    molarHeat: 23.824,

    number: 15,
    period: 3,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Phosphorus",

    summary:
      "Engine hours tells you the actual hours an engine has run, which is different from what is tracked by the odometer, which is actual miles driven. For example, the odometer reading would not include time idling at a stop light. In high-idling applications, this measurement can help provide more accurate maintenance parameters. This is also how electronic logging devices (ELDs) are able to automatically log driver hours. Read more about engine hours and idling in this article.",
    symbol: "Eh",
    group: 15,

    shells: [2, 8, 5],

    electronAffinity: 72.037,
    electronegativityPauling: 2.19,
    ionizationEnergies: [
      1011.8,
      1907,
      2914.1,
      4963.6,
      6273.9,
      21267,
      25431,
      29872,
      35905,
      40950,
      46261,
      54110,
      59024,
      271791,
      296195,
    ],
    earthAbundance: 1050,
  },
  {
    name: "Fleet Rightsizing",
    appearance: "lemon yellow sintered microcrystals",
    atomicMass: 32.06,
    boil: 717.8,
    category: "Fleet Optimization",
    color: null,
    density: 2.07,
    discoveredBy: "Ancient china",
    melt: 388.36,
    molarHeat: 22.75,

    number: 16,
    period: 3,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Sulfur",

    summary:
      "Fleet rightsizing is a proactive, strategic plan to have the right type of vehicle, at the right locations and available at the right time. It ultimately can help fleet managers have sustainable fleets.",
    symbol: "Fr",
    group: 16,

    shells: [2, 8, 6],

    electronAffinity: 200.4101,
    electronegativityPauling: 2.58,
    ionizationEnergies: [
      999.6,
      2252,
      3357,
      4556,
      7004.3,
      8495.8,
      27107,
      31719,
      36621,
      43177,
      48710,
      54460,
      62930,
      68216,
      311048,
      337138,
    ],
    earthAbundance: 350,
  },
  {
    name: "Fuel Economy",
    appearance: "pale yellow-green gas",
    atomicMass: 35.45,
    boil: 239.11,
    category: "Fleet Optimization",
    color: null,
    density: 3.2,
    discoveredBy: "Carl Wilhelm Scheele",
    melt: 171.6,
    molarHeat: null,

    number: 17,
    period: 3,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Chlorine",

    summary:
      "Fuel economy is the relation in distance that a vehicle travels and how much fuel is consumed during that trip.",
    symbol: "Fe",
    group: 17,

    shells: [2, 8, 7],

    electronAffinity: 348.575,
    electronegativityPauling: 3.16,
    ionizationEnergies: [
      1251.2,
      2298,
      3822,
      5158.6,
      6542,
      9362,
      11018,
      33604,
      38600,
      43961,
      51068,
      57119,
      63363,
      72341,
      78095,
      352994,
      380760,
    ],
    earthAbundance: 145,
  },
  {
    name: "ELD",
    appearance:
      "colorless gas exhibiting a lilac/violet glow when placed in a high voltage electric field",
    atomicMass: 39.9481,
    boil: 87.302,
    category: "Compliance",
    color: null,
    density: 1.784,
    discoveredBy: "Lord Rayleigh",
    melt: 83.81,
    molarHeat: null,

    number: 18,
    period: 3,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Argon",

    summary:
      "An electronic logging device, also called an ELD, is technology for drivers of commercial motor vehicles (CMVs) to automatically record driving time and Hours of service (HOS) records and capture data on the vehicle’s engine, movement, and miles driven. The Federal Motor Carrier Safety Administration (FMCSA) mandated the use of ELDs for the commercial truck and bus industries as a means of improving road safety, strengthening compliance, and protecting commercial drivers. To learn more and see the compliance timeline, read this Quick Guide to the FMCSA’s ELD Mandate.",
    symbol: "El",
    group: 18,

    shells: [2, 8, 8],

    electronAffinity: -96,
    electronegativityPauling: null,
    ionizationEnergies: [
      1520.6,
      2665.8,
      3931,
      5771,
      7238,
      8781,
      11995,
      13842,
      40760,
      46186,
      52002,
      59653,
      66199,
      72918,
      82473,
      88576,
      397605,
      427066,
    ],
    earthAbundance: 3.5,
  },
  {
    name: "GO TALK",
    appearance: "silvery gray",
    atomicMass: 39.09831,
    boil: 1032,
    category: "Hardware",
    color: null,
    density: 0.862,
    discoveredBy: "Humphry Davy",
    melt: 336.7,
    molarHeat: 29.6,

    number: 19,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Potassium",

    summary:
      "Geotab’s GO TALK is a proprietary driver coaching solution that delivers spoken messages to the driver in near real-time to help improve fleet safety. It does this by tracking harsh cornering, speeding and other risky behaviors and letting a driver know immediately that they should modify or change a behavior. Read an interview with two product experts on GO TALK.",
    symbol: "Gt",
    group: 1,

    shells: [2, 8, 8, 1],

    electronAffinity: 48.383,
    electronegativityPauling: 0.82,
    ionizationEnergies: [
      418.8,
      3052,
      4420,
      5877,
      7975,
      9590,
      11343,
      14944,
      16963.7,
      48610,
      54490,
      60730,
      68950,
      75900,
      83080,
      93400,
      99710,
      444880,
      476063,
    ],
    earthAbundance: 20900,
  },
  {
    name: "Geotab Drive",
    appearance: null,
    atomicMass: 40.0784,
    boil: 1757,
    category: "Software",
    color: null,
    density: 1.55,
    discoveredBy: "Humphry Davy",
    melt: 1115,
    molarHeat: 25.929,

    number: 20,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Calcium",

    summary:
      "Geotab Drive is a proprietary Mobile App used in conjunction with Geotab GO telematics device, used for hours of service (HOS) logging, driver identification, driver vehicle inspection reports (DVIR) and driver messaging.",
    symbol: "Dr",
    group: 2,

    shells: [2, 8, 8, 2],

    electronAffinity: 2.37,
    electronegativityPauling: 1,
    ionizationEnergies: [
      589.8,
      1145.4,
      4912.4,
      6491,
      8153,
      10496,
      12270,
      14206,
      18191,
      20385,
      57110,
      63410,
      70110,
      78890,
      86310,
      94000,
      104900,
      111711,
      494850,
      527762,
    ],
    earthAbundance: 41500,
  },
  {
    name: "3G Sunset",
    appearance: "silvery white",
    atomicMass: 44.9559085,
    boil: 3109,
    category: "General",
    color: null,
    density: 2.985,
    discoveredBy: "Lars Fredrik Nilson",
    melt: 1814,
    molarHeat: 25.52,

    number: 21,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Scandium",

    summary:
      "Similarly to the previous 2G network shutdown, the 3G sunset refers to the period when major cellular network carriers began phasing out or “sunsetting” their 3G networks, to allow for a transition to 4G LTE and 5G network use.",
    symbol: "3C",
    group: 3,

    shells: [2, 8, 9, 2],

    electronAffinity: 18,
    electronegativityPauling: 1.36,
    ionizationEnergies: [
      633.1,
      1235,
      2388.6,
      7090.6,
      8843,
      10679,
      13310,
      15250,
      17370,
      21726,
      24102,
      66320,
      73010,
      80160,
      89490,
      97400,
      105600,
      117000,
      124270,
      547530,
      582163,
    ],
    earthAbundance: 22,
  },
  {
    name: "4G LTE Network",
    appearance: "silvery grey-white metallic",
    atomicMass: 47.8671,
    boil: 3560,
    category: "General",
    color: null,
    density: 4.506,
    discoveredBy: "William Gregor",
    melt: 1941,
    molarHeat: 25.06,

    number: 22,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Titanium",

    summary:
      "4G LTE connectivity for telematics devices provides a greater level of speed and efficiency for cloud-based fleet management and solution integrations. The term “4G LTE” is an acronym for “fourth generation long-term evolution.",
    symbol: "4G",
    group: 4,

    shells: [2, 8, 10, 2],

    electronAffinity: 7.289,
    electronegativityPauling: 1.54,
    ionizationEnergies: [
      658.8,
      1309.8,
      2652.5,
      4174.6,
      9581,
      11533,
      13590,
      16440,
      18530,
      20833,
      25575,
      28125,
      76015,
      83280,
      90880,
      100700,
      109100,
      117800,
      129900,
      137530,
      602930,
      639294,
    ],
    earthAbundance: 5650,
  },
  {
    name: "5G Network",
    appearance: "blue-silver-grey metal",
    atomicMass: 50.94151,
    boil: 3680,
    category: "General",
    color: null,
    density: 6,
    discoveredBy: "Andrés Manuel del Río",
    melt: 2183,
    molarHeat: 24.89,

    number: 23,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Vanadium",

    summary:
      "The 5G network is the fifth generation of telecommunication technology used by cellular networks to transmit data around the world. This standard builds on 4G and allows increased capacity and faster speeds. There is a part of 5G called Category M which is optimized for IoT and devices like the Geotab GO.",
    symbol: "5G",
    group: 5,

    shells: [2, 8, 11, 2],

    electronAffinity: 50.911,
    electronegativityPauling: 1.63,
    ionizationEnergies: [
      650.9,
      1414,
      2830,
      4507,
      6298.7,
      12363,
      14530,
      16730,
      19860,
      22240,
      24670,
      29730,
      32446,
      86450,
      94170,
      102300,
      112700,
      121600,
      130700,
      143400,
      151440,
      661050,
      699144,
    ],
    earthAbundance: 120,
  },
  {
    name: "Active Tracking",
    appearance: "silvery metallic",
    atomicMass: 51.99616,
    boil: 2944,
    category: "General",
    color: null,
    density: 7.19,
    discoveredBy: "Louis Nicolas Vauquelin",
    melt: 2180,
    molarHeat: 23.35,

    number: 24,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Chromium",

    summary:
      "Active Tracking is a proprietary software feature in MyGeotab that provides faster location information at a more granular level, ideal for industries that need precise and immediate vehicle location, such as in emergency/medical services. Speed, turns and stops can be seen by a dispatcher in near real-time to ensure a vehicle gets to its location safely. Read more about how it works.",
    symbol: "At",
    group: 6,

    shells: [2, 8, 13, 1],

    electronAffinity: 65.21,
    electronegativityPauling: 1.66,
    ionizationEnergies: [
      652.9,
      1590.6,
      2987,
      4743,
      6702,
      8744.9,
      15455,
      17820,
      20190,
      23580,
      26130,
      28750,
      34230,
      37066,
      97510,
      105800,
      114300,
      125300,
      134700,
      144300,
      157700,
      166090,
      721870,
      761733,
    ],
    earthAbundance: 102,
  },
  {
    name: "Autonomous Vehicles",
    appearance: "silvery metallic",
    atomicMass: 54.9380443,
    boil: 2334,
    category: "General",
    color: null,
    density: 7.21,
    discoveredBy: "Torbern Olof Bergman",
    melt: 1519,
    molarHeat: 26.32,

    number: 25,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Manganese",

    summary:
      "With several “levels” of autonomous technology, the highest level is self-driving cars, trucks, buses and all. Using sensors, cameras, and telematics data to detect other cars and conditions around the vehicle, autonomous vehicle technology allows the vehicle to go without an operator. Many companies have research and pilot programs happening now but it’s likely still many years off to be a mainstream vehicle.",
    symbol: "Av",
    group: 7,

    shells: [2, 8, 13, 2],

    electronAffinity: -50,
    electronegativityPauling: 1.55,
    ionizationEnergies: [
      717.3,
      1509,
      3248,
      4940,
      6990,
      9220,
      11500,
      18770,
      21400,
      23960,
      27590,
      30330,
      33150,
      38880,
      41987,
      109480,
      118100,
      127100,
      138600,
      148500,
      158600,
      172500,
      181380,
      785450,
      827067,
    ],
    earthAbundance: 950,
  },
  {
    name: "Business Intelligence",
    appearance: "lustrous metallic with a grayish tinge",
    atomicMass: 55.8452,
    boil: 3134,
    category: "General",
    color: null,
    density: 7.874,
    discoveredBy: "5000 BC",
    melt: 1811,
    molarHeat: 25.1,

    number: 26,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Iron",

    summary:
      "Data analytics is the process of taking big data and turning it into Business Intelligence, meaning all the data collected is turned into palatable, understandable reports that lead to actionable insights. These data-driven decisions are considered to have a positive impact on operations by finding inefficiencies, or identifying good processes and replicating them.",
    symbol: "Bi",
    group: 8,

    shells: [2, 8, 14, 2],

    electronAffinity: 14.785,
    electronegativityPauling: 1.83,
    ionizationEnergies: [
      762.5,
      1561.9,
      2957,
      5290,
      7240,
      9560,
      12060,
      14580,
      22540,
      25290,
      28000,
      31920,
      34830,
      37840,
      44100,
      47206,
      122200,
      131000,
      140500,
      152600,
      163000,
      173600,
      188100,
      195200,
      851800,
      895161,
    ],
    earthAbundance: 56300,
  },
  {
    name: "CAN Bus",
    appearance: "hard lustrous gray metal",
    atomicMass: 58.9331944,
    boil: 3200,
    category: "General",
    color: "metallic gray",
    density: 8.9,
    discoveredBy: "Georg Brandt",
    melt: 1768,
    molarHeat: 24.81,

    number: 27,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Cobalt",

    summary:
      "The controller area network bus or CAN bus system connects and facilitates communication between all engine computer units (ECUs) in vehicles today.",
    symbol: "Cb",
    group: 9,

    shells: [2, 8, 15, 2],

    electronAffinity: 63.898,
    electronegativityPauling: 1.88,
    ionizationEnergies: [
      760.4,
      1648,
      3232,
      4950,
      7670,
      9840,
      12440,
      15230,
      17959,
      26570,
      29400,
      32400,
      36600,
      39700,
      42800,
      49396,
      52737,
      134810,
      145170,
      154700,
      167400,
      178100,
      189300,
      204500,
      214100,
      920870,
      966023,
    ],
    earthAbundance: 25,
  },
  {
    name: "Connected Vehicles",
    appearance: "lustrous, metallic, and silver with a gold tinge",
    atomicMass: 58.69344,
    boil: 3003,
    category: "General",
    color: null,
    density: 8.908,
    discoveredBy: "Axel Fredrik Cronstedt",
    melt: 1728,
    molarHeat: 26.07,

    number: 28,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Nickel",

    summary:
      "Connected vehicle technology is used around the world to support productivity, efficiency, sustainability and compliance in business and government and is essential to safety, competitiveness and innovation. Wireless vehicle connection is made possible through vehicle-to-vehicle communication and vehicle-to-infrastructure communication. For example, a vehicle-to-infrastructure relationship could be a weather alert system sending a notification to drivers in the area.",
    symbol: "Cv",
    group: 10,

    shells: [2, 8, 16, 2],

    electronAffinity: 111.65,
    electronegativityPauling: 1.91,
    ionizationEnergies: [
      737.1,
      1753,
      3395,
      5300,
      7339,
      10400,
      12800,
      15600,
      18600,
      21670,
      30970,
      34000,
      37100,
      41500,
      44800,
      48100,
      55101,
      58570,
      148700,
      159000,
      169400,
      182700,
      194000,
      205600,
      221400,
      231490,
      992718,
      1039668,
    ],
    earthAbundance: 84,
  },
  {
    name: "Curve Logging Algorithm",
    appearance: "red-orange metallic luster",
    atomicMass: 63.5463,
    boil: 2835,
    category: "General",
    color: null,
    density: 8.96,
    discoveredBy: "Middle East",
    melt: 1357.77,
    molarHeat: 24.44,

    number: 29,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Copper",

    summary:
      "The Curve Logging Algorithm is a proprietary patented algorithm used by Geotab in processing large amounts of telematics data. The algorithm makes calculations to identify unnecessary points of data and discard them, while preserving the most important information.",
    symbol: "Cl",
    group: 11,

    shells: [2, 8, 18, 1],

    electronAffinity: 119.235,
    electronegativityPauling: 1.9,
    ionizationEnergies: [
      745.5,
      1957.9,
      3555,
      5536,
      7700,
      9900,
      13400,
      16000,
      19200,
      22400,
      25600,
      35600,
      38700,
      42000,
      46700,
      50200,
      53700,
      61100,
      64702,
      163700,
      174100,
      184900,
      198800,
      210500,
      222700,
      239100,
      249660,
      1067358,
      1116105,
    ],
    earthAbundance: 60,
  },
  {
    name: "Cybersecurity",
    appearance: "silver-gray",
    atomicMass: 65.382,
    boil: 1180,
    category: "General",
    color: null,
    density: 7.14,
    discoveredBy: "India",
    melt: 692.68,
    molarHeat: 25.47,

    number: 30,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Zinc",

    summary:
      "With any type of data getting transmitted, there is always the need for cybersecurity. The FBI, NHTSA, and NAFA have all expressed the need for greater awareness and action on cybersecurity with regard to connected vehicles. Learn about best practices for cybersecurity in telematics in this blog post on cybersecurity management.",
    symbol: "Cs",
    group: 12,

    shells: [2, 8, 18, 2],

    electronAffinity: -58,
    electronegativityPauling: 1.65,
    ionizationEnergies: [
      906.4,
      1733.3,
      3833,
      5731,
      7970,
      10400,
      12900,
      16800,
      19600,
      23000,
      26400,
      29990,
      40490,
      43800,
      47300,
      52300,
      55900,
      59700,
      67300,
      71200,
      179100,
    ],
    earthAbundance: 70,
  },
  {
    name: "Aggressive Driving",
    appearance: "silver-white",
    atomicMass: 69.7231,
    boil: 2673,
    category: "Safety",
    color: null,
    density: 5.91,
    discoveredBy: "Lecoq de Boisbaudran",
    melt: 302.9146,
    molarHeat: 25.86,

    number: 31,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Gallium",

    summary:
      "This is a type of high-risk driving behavior that can be tracked by a telematics device. Aggressive driving includes speeding, which has its obvious risks; harsh braking, which can indicate the driver was following too closely or distracted; hard acceleration, which reduces chance of reacting on time, not to mention isn’t fuel efficient; and hard cornering, which can also indicate distracted driving or even drowsy driving. Telematics can help curb aggressive driving, through risk and safety monitoring, driver coaching tools and driver recognition/reward programs.",
    symbol: "Ag",
    group: 13,

    shells: [2, 8, 18, 3],

    electronAffinity: 41,
    electronegativityPauling: 1.81,
    ionizationEnergies: [578.8, 1979.3, 2963, 6180],
    earthAbundance: 19,
  },
  {
    name: "Geofencing",
    appearance: "grayish-white",
    atomicMass: 72.6308,
    boil: 3106,
    category: "Productivity",
    color: null,
    density: 5.323,
    discoveredBy: "Clemens Winkler",
    melt: 1211.4,
    molarHeat: 23.222,

    number: 32,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Germanium",

    summary:
      "Geofencing allows managers to create zones of various types such as an office or customer location. For example, if a certain vehicle shouldn’t leave a particular jobsite, a fleet manager could set up a geofence for that vehicle around the area it should stay in. With exception reporting, the manager can then receive alerts if that vehicle travels outside the geofence. A technical services engineer explains how to create a zone in MyGeotab here. See also: What is geofencing?",
    symbol: "Fe",
    group: 14,

    shells: [2, 8, 18, 4],

    electronAffinity: 118.9352,
    electronegativityPauling: 2.01,
    ionizationEnergies: [762, 1537.5, 3302.1, 4411, 9020],
    earthAbundance: 1.5,
  },
  {
    name: "Nearest Vehicle",
    appearance: "metallic grey",
    atomicMass: 74.9215956,
    boil: null,
    category: "Productivity",
    color: null,
    density: 5.727,
    discoveredBy: "Bronze Age",
    melt: null,
    molarHeat: 24.64,

    number: 33,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Arsenic",

    summary:
      "Using telematics, fleets can improve dispatching through a feature that makes it possible to locate the nearest vehicle to a particular customer stop on a map. For example, when a service or a first responder fleet gets an emergency call, instead of calling each mobile worker to check if they can respond to the job and exactly where they are, a dispatcher can easily see which vehicle and worker is closest to the job and dispatch and route them straight from where they are.",
    symbol: "Nv",
    group: 15,

    shells: [2, 8, 18, 5],

    electronAffinity: 77.65,
    electronegativityPauling: 2.18,
    ionizationEnergies: [947, 1798, 2735, 4837, 6043, 12310],
    earthAbundance: 1.8,
  },
  {
    name: "Fuel Usage",
    appearance: "black, red, and gray (not pictured) allotropes",
    atomicMass: 78.9718,
    boil: 958,
    category: "Fleet Optimization",
    color: null,
    density: 4.81,
    discoveredBy: "Jöns Jakob Berzelius",
    melt: 494,
    molarHeat: 25.363,

    number: 34,
    period: 4,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Selenium",

    summary:
      "This measurement indicates how much fuel is consumed by vehicle. Learn more about how Geotab measures fuel usage.",
    symbol: "Fu",
    group: 16,

    shells: [2, 8, 18, 6],

    electronAffinity: 194.9587,
    electronegativityPauling: 2.55,
    ionizationEnergies: [941, 2045, 2973.7, 4144, 6590, 7880, 14990],
    earthAbundance: 0.05,
  },
  {
    name: "Idle Trends",
    appearance: null,
    atomicMass: 79.904,
    boil: 332,
    category: "Fleet Optimization",
    color: null,
    density: 3.1028,
    discoveredBy: "Antoine Jérôme Balard",
    melt: 265.8,
    molarHeat: null,

    number: 35,
    period: 4,
    phase: "Liquid",
    source: "https://en.wikipedia.org/wiki/Bromine",

    summary:
      "Idle trends show when, where and for how long true idling or wasted time events occurred. By viewing these, it becomes possible to calculate a breakdown of the amount of time vehicle idling is occurring which can then help fleets determine trends in idling.",
    symbol: "It",
    group: 17,

    shells: [2, 8, 18, 7],

    electronAffinity: 324.537,
    electronegativityPauling: 2.96,
    ionizationEnergies: [1139.9, 2103, 3470, 4560, 5760, 8550, 9940, 18600],
    earthAbundance: 2.4,
  },
  {
    name: "Fleet Compliance",
    appearance:
      "colorless gas, exhibiting a whitish glow in a high electric field",
    atomicMass: 83.7982,
    boil: 119.93,
    category: "Compliance",
    color: null,
    density: 3.749,
    discoveredBy: "William Ramsay",
    melt: 115.78,
    molarHeat: null,

    number: 36,
    period: 4,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Krypton",

    summary:
      "Keeping up with compliance standards is a key part of fleet management, especially during times of crisis. Fleet compliance refers to the adherence to regulations such as electronic driver logging (ELD), tax reporting and driver vehicle inspection reporting (DVIR) to name a few.",
    symbol: "Fc",
    group: 18,

    shells: [2, 8, 18, 8],

    electronAffinity: -96,
    electronegativityPauling: 3,
    ionizationEnergies: [
      1350.8,
      2350.4,
      3565,
      5070,
      6240,
      7570,
      10710,
      12138,
      22274,
      25880,
      29700,
      33800,
      37700,
      43100,
      47500,
      52200,
      57100,
      61800,
      75800,
      80400,
      85300,
      90400,
      96300,
      101400,
      111100,
      116290,
      282500,
      296200,
      311400,
      326200,
    ],
    earthAbundance: 0.0001,
  },
  {
    name: "NFC",
    appearance: "grey white",
    atomicMass: 85.46783,
    boil: 961,
    category: "Hardware",
    color: null,
    density: 1.532,
    discoveredBy: "Robert Bunsen",
    melt: 312.45,
    molarHeat: 31.06,

    number: 37,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Rubidium",

    summary:
      "Near-field communication (NFC) is a collection of communication protocols that enables communication between two nearby devices. In fleet management, it can be used in conjunction with telematics devices to verify driver identity and allow sign-in to specific vehicles.",
    symbol: "Nf",
    group: 1,

    shells: [2, 8, 18, 8, 1],

    electronAffinity: 46.884,
    electronegativityPauling: 0.82,
    ionizationEnergies: [
      403,
      2633,
      3860,
      5080,
      6850,
      8140,
      9570,
      13120,
      14500,
      26740,
    ],
    earthAbundance: 90,
  },
  {
    name: "MyAdmin",
    appearance: null,
    atomicMass: 87.621,
    boil: 1650,
    category: "Software",
    color: null,
    density: 2.64,
    discoveredBy: "William Cruickshank (chemist)",
    melt: 1050,
    molarHeat: 26.4,

    number: 38,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Strontium",

    summary:
      "MyAdmin is a proprietary system allowing Geotab Resellers and Partners to utilize a variety of tools including view reports, browse products, open support tickets, view their devices, billing information etc.",
    symbol: "Ma",
    group: 2,

    shells: [2, 8, 18, 8, 2],

    electronAffinity: 5.023,
    electronegativityPauling: 0.95,
    ionizationEnergies: [
      549.5,
      1064.2,
      4138,
      5500,
      6910,
      8760,
      10230,
      11800,
      15600,
      17100,
      31270,
    ],
    earthAbundance: 370,
  },
  {
    name: "Dashboard Report",
    appearance: "silvery white",
    atomicMass: 88.905842,
    boil: 3203,
    category: "General",
    color: null,
    density: 4.472,
    discoveredBy: "Johan Gadolin",
    melt: 1799,
    molarHeat: 26.53,

    number: 39,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Yttrium",

    summary:
      "Dashboard reports can be used to suit your fleet needs. Users can get key insights into fleet operations, maintenance needs and costs for improved performance results and view them on their dashboard. ",
    symbol: "Da",
    group: 3,

    shells: [2, 8, 18, 9, 2],

    electronAffinity: 29.6,
    electronegativityPauling: 1.22,
    ionizationEnergies: [
      600,
      1180,
      1980,
      5847,
      7430,
      8970,
      11190,
      12450,
      14110,
      18400,
      19900,
      36090,
    ],
    earthAbundance: 33,
  },
  {
    name: "Data Analytics",
    appearance: "silvery white",
    atomicMass: 91.2242,
    boil: 4650,
    category: "General",
    color: null,
    density: 6.52,
    discoveredBy: "Martin Heinrich Klaproth",
    melt: 2128,
    molarHeat: 25.36,

    number: 40,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Zirconium",

    summary:
      "The examination or analyzation of datasets in order to draw conclusions about that data. This allows patterns and trends to be defined and gain valuable insight from the collected data.",
    symbol: "Da",
    group: 4,

    shells: [2, 8, 18, 10, 2],

    electronAffinity: 41.806,
    electronegativityPauling: 1.33,
    ionizationEnergies: [640.1, 1270, 2218, 3313, 7752, 9500],
    earthAbundance: 165,
  },
  {
    name: "Data Feed",
    appearance: "gray metallic, bluish when oxidized",
    atomicMass: 92.906372,
    boil: 5017,
    category: "General",
    color: null,
    density: 8.57,
    discoveredBy: "Charles Hatchett",
    melt: 2750,
    molarHeat: 24.6,

    number: 41,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Niobium",

    summary:
      "The Geotab Data Feed is the application that allows telematics data to flow from a fleet’s devices to MyGeotab for management.",
    symbol: "Df",
    group: 5,

    shells: [2, 8, 18, 12, 1],

    electronAffinity: 88.516,
    electronegativityPauling: 1.6,
    ionizationEnergies: [652.1, 1380, 2416, 3700, 4877, 9847, 12100],
    earthAbundance: 20,
  },
  {
    name: "Data Normalization",
    appearance: "gray metallic",
    atomicMass: 95.951,
    boil: 4912,
    category: "General",
    color: null,
    density: 10.28,
    discoveredBy: "Carl Wilhelm Scheele",
    melt: 2896,
    molarHeat: 24.06,

    number: 42,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Molybdenum",

    summary:
      "Data normalization is the process of standardizing data to provide aggregated information on various vehicle features.",
    symbol: "Dn",
    group: 6,

    shells: [2, 8, 18, 13, 1],

    electronAffinity: 72.1,
    electronegativityPauling: 2.16,
    ionizationEnergies: [
      684.3,
      1560,
      2618,
      4480,
      5257,
      6640.8,
      12125,
      13860,
      15835,
      17980,
      20190,
      22219,
      26930,
      29196,
      52490,
      55000,
      61400,
      67700,
      74000,
      80400,
      87000,
      93400,
      98420,
      104400,
      121900,
      127700,
      133800,
      139800,
      148100,
      154500,
    ],
    earthAbundance: 1.2,
  },
  {
    name: "Data Privacy",
    appearance: "shiny gray metal",
    atomicMass: 98,
    boil: 4538,
    category: "General",
    color: null,
    density: 11,
    discoveredBy: "Emilio Segrè",
    melt: 2430,
    molarHeat: 24.27,

    number: 43,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Technetium",

    summary:
      "Strong data governance in telematics is essential to protecting the privacy of personal and vehicle data. Read why every company should be thinking about digital responsibility and data privacy.",
    symbol: "Dp",
    group: 7,

    shells: [2, 8, 18, 13, 2],

    electronAffinity: 53,
    electronegativityPauling: 1.9,
    ionizationEnergies: [702, 1470, 2850],
    earthAbundance: 0.00000000000135,
  },
  {
    name: "Data Visualization",
    appearance: "silvery white metallic",
    atomicMass: 101.072,
    boil: 4423,
    category: "General",
    color: null,
    density: 12.45,
    discoveredBy: "Karl Ernst Claus",
    melt: 2607,
    molarHeat: 24.06,

    number: 44,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Ruthenium",

    summary:
      "Data visualization is the process of translating telematics data into a visual representation or software dashboard on the computer, to make it easier for fleets to pinpoint actions and make decisions. It shows trends on different fleet metrics, such as daily idling averages, the safest drivers over the last month, average fleet MPG, and others.",
    symbol: "Vz",
    group: 8,

    shells: [2, 8, 18, 15, 1],

    electronAffinity: 100.96,
    electronegativityPauling: 2.2,
    ionizationEnergies: [710.2, 1620, 2747],
    earthAbundance: 0.001,
  },
  {
    name: "Digital Transformation",
    appearance: "silvery white metallic",
    atomicMass: 102.905502,
    boil: 3968,
    category: "General",
    color: null,
    density: 12.41,
    discoveredBy: "William Hyde Wollaston",
    melt: 2237,
    molarHeat: 24.98,

    number: 45,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Rhodium",

    summary:
      "Digital transformation is a global movement in the business economy, which includes the adoption of technology, automation, and connection to real-time data for process optimization and increased competitiveness. Examples of digital transformation is the movement toward cloud data storage.",
    symbol: "Dt",
    group: 9,

    shells: [2, 8, 18, 16, 1],

    electronAffinity: 110.27,
    electronegativityPauling: 2.28,
    ionizationEnergies: [719.7, 1740, 2997],
    earthAbundance: 0.001,
  },
  {
    name: "Encryption",
    appearance: "silvery white",
    atomicMass: 106.421,
    boil: 3236,
    category: "General",
    color: null,
    density: 12.023,
    discoveredBy: "William Hyde Wollaston",
    melt: 1828.05,
    molarHeat: 25.98,

    number: 46,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Palladium",

    summary:
      "Encryption is the process of encoding a message such that only the sender and recipient would be able to view the message. To an outside party, like an attacker, this encoded message would appear as a meaningless collection of symbols. The intended recipient of the message, using a special key, can turn this collection of symbols into intelligible information. A secure communication channel can be established with the use of encryption.",
    symbol: "En",
    group: 10,

    shells: [2, 8, 18, 18],

    electronAffinity: 54.24,
    electronegativityPauling: 2.2,
    ionizationEnergies: [804.4, 1870, 3177],
    earthAbundance: 0.015,
  },
  {
    name: "FIPS 140-2 Validation",
    appearance: "lustrous white metal",
    atomicMass: 107.86822,
    boil: 2435,
    category: "General",
    color: null,
    density: 10.49,
    discoveredBy: "unknown, before 5000 BC",
    melt: 1234.93,
    molarHeat: 25.35,

    number: 47,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Silver",

    summary:
      "FIPS 140-2 validation is a benchmark for cryptographic modules which protects sensitive computer and telecommunication system data for the U.S. and Canadian government as well as for the military.",
    symbol: "Fv",
    group: 11,

    shells: [2, 8, 18, 18, 1],

    electronAffinity: 125.862,
    electronegativityPauling: 1.93,
    ionizationEnergies: [731, 2070, 3361],
    earthAbundance: 0.075,
  },
  {
    name: "Fleet Management",
    appearance: "silvery bluish-gray metallic",
    atomicMass: 112.4144,
    boil: 1040,
    category: "General",
    color: null,
    density: 8.65,
    discoveredBy: "Karl Samuel Leberecht Hermann",
    melt: 594.22,
    molarHeat: 26.02,

    number: 48,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Cadmium",

    summary:
      "Fleet management involves a series of diverse tasks for businesses who rely on transportation, aimed at controlling costs, productivity, efficiency and risks in vehicle acquisition, fuel management, compliance and more. It covers the scope of many industries from freight, to delivery, sales and service, oil & gas, and emergency services. Any business that owns or leases vehicles is engaged in some form of fleet management to provide solutions for keeping operations running efficiently, remaining competitive in the marketplace and meeting their budget goals.",
    symbol: "Fm",
    group: 12,

    shells: [2, 8, 18, 18, 2],

    electronAffinity: -68,
    electronegativityPauling: 1.69,
    ionizationEnergies: [867.8, 1631.4, 3616],
    earthAbundance: 0.15,
  },
  {
    name: "Collision Reconstruction",
    appearance: "silvery lustrous gray",
    atomicMass: 114.8181,
    boil: 2345,
    category: "Safety",
    color: null,
    density: 7.31,
    discoveredBy: "Ferdinand Reich",
    melt: 429.7485,
    molarHeat: 26.74,

    number: 49,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Indium",

    summary:
      "Fleets can use telematics data to help reconstruct the events of a vehicle collision. Learn more on how collision detection works and how to analyze and interpret data in this white paper.",
    symbol: "Cr",
    group: 13,

    shells: [2, 8, 18, 18, 3],

    electronAffinity: 37.043,
    electronegativityPauling: 1.78,
    ionizationEnergies: [558.3, 1820.7, 2704, 5210],
    earthAbundance: 0.25,
  },
  {
    name: "Dash Cam",
    appearance: "silvery-white (beta) or gray (alpha)",
    atomicMass: 118.7107,
    boil: 2875,
    category: "Safety",
    color: null,
    density: 7.365,
    discoveredBy: "unknown, before 3500 BC",
    melt: 505.08,
    molarHeat: 27.112,

    number: 50,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Tin",

    summary:
      "Dash cams (also known as dashboard cameras) are video recording devices mounted on the front dashboard of a vehicle to capture footage while a vehicle is in operation. These cameras can be installed to look out at the road, showing the vantage point of the driver, or pointed inwards to monitor driver behavior. Dash cams are useful tools in verifying a driver’s account of events during a collision or for ensuring drivers adhere to company driving standards when operating a vehicle.",
    symbol: "Cm",
    group: 14,

    shells: [2, 8, 18, 18, 4],

    electronAffinity: 107.2984,
    electronegativityPauling: 1.96,
    ionizationEnergies: [708.6, 1411.8, 2943, 3930.3, 7456],
    earthAbundance: 2.3,
  },
  {
    name: "Routing",
    appearance: "silvery lustrous gray",
    atomicMass: 121.7601,
    boil: 1908,
    category: "Productivity",
    color: null,
    density: 6.697,
    discoveredBy: "unknown, before 3000 BC",
    melt: 903.78,
    molarHeat: 25.23,

    number: 51,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Antimony",

    summary:
      "Routing refers to getting each driver out on the road as fast as possible, in the right vehicle, with the right qualifications and eligibility, and completing each stop based on time frames or customer expectations.",
    symbol: "Ro",
    group: 15,

    shells: [2, 8, 18, 18, 5],

    electronAffinity: 101.059,
    electronegativityPauling: 2.05,
    ionizationEnergies: [834, 1594.9, 2440, 4260, 5400, 10400],
    earthAbundance: 0.2,
  },
  {
    name: "Uptime",
    appearance: null,
    atomicMass: 127.603,
    boil: 1261,
    category: "General",
    color: null,
    density: 6.24,
    discoveredBy: "Franz-Joseph Müller von Reichenstein",
    melt: 722.66,
    molarHeat: 25.73,

    number: 52,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Tellurium",

    summary:
      "Time in which the vehicle is in operation and is able to perform it's intended functions or duties.",
    symbol: "Ut",
    group: 16,

    shells: [2, 8, 18, 18, 6],

    electronAffinity: 190.161,
    electronegativityPauling: 2.1,
    ionizationEnergies: [869.3, 1790, 2698, 3610, 5668, 6820, 13200],
    earthAbundance: 0.001,
  },
  {
    name: "Keyless",
    appearance: "lustrous metallic gray, violet as a gas",
    atomicMass: 126.904473,
    boil: 457.4,
    category: "Fleet Optimization",
    color: null,
    density: 4.933,
    discoveredBy: "Bernard Courtois",
    melt: 386.85,
    molarHeat: null,

    number: 53,
    period: 5,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Iodine",

    summary:
      "The use of technology to perform actions without the use of a traditional key. Examples can include the ability to lock or unlock a vehicle from a device.",
    symbol: "Ky",
    group: 17,

    shells: [2, 8, 18, 18, 7],

    electronAffinity: 295.1531,
    electronegativityPauling: 2.66,
    ionizationEnergies: [1008.4, 1845.9, 3180],
    earthAbundance: 0.45,
  },
  {
    name: "HOS",
    appearance:
      "colorless gas, exhibiting a blue glow when placed in a high voltage electric field",
    atomicMass: 131.2936,
    boil: 165.051,
    category: "Compliance",
    color: null,
    density: 5.894,
    discoveredBy: "William Ramsay",
    melt: 161.4,
    molarHeat: null,

    number: 54,
    period: 5,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Xenon",

    summary:
      "Hours of service (HOS) are the regulations in the commercial vehicle industry, namely for over-the-road fleets but it does cover many commercial vehicle drivers, that govern how many hours that drivers can drive and when they must take breaks. Also related to: electronic logging.",
    symbol: "Hs",
    group: 18,

    shells: [2, 8, 18, 18, 8],

    electronAffinity: -77,
    electronegativityPauling: 2.6,
    ionizationEnergies: [1170.4, 2046.4, 3099.4],
    earthAbundance: 0.00003,
  },
  {
    name: "OBD II",
    appearance: "silvery gold",
    atomicMass: 132.905451966,
    boil: 944,
    category: "Hardware",
    color: null,
    density: 1.93,
    discoveredBy: "Robert Bunsen",
    melt: 301.7,
    molarHeat: 32.21,

    number: 55,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Cesium",

    summary:
      "On-board diagnostics port (OBD-II) is an automotive electronic system for vehicle self-diagnosis and reporting capabilities. Read more about OBD II, the role it plays in telematics and fleet management.",
    symbol: "Ob",
    group: 1,

    shells: [2, 8, 18, 18, 8, 1],

    electronAffinity: 45.505,
    electronegativityPauling: 0.79,
    ionizationEnergies: [375.7, 2234.3, 3400],
    earthAbundance: 3,
  },
  {
    name: "MyGeotab",
    appearance: null,
    atomicMass: 137.3277,
    boil: 2118,
    category: "Software",
    color: null,
    density: 3.51,
    discoveredBy: "Carl Wilhelm Scheele",
    melt: 1000,
    molarHeat: 28.07,

    number: 56,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Barium",

    summary:
      "MyGeotab is the proprietary fleet management software that pairs with the Geotab GO telematics device (though the software is device-agnostic and can be used with other telematics devices). The web-based, scalable software provides dashboards to actually view the data and trends about a fleet, view and export reports and benchmarking data. MyGeotab is at the heart of what makes the system friendly for the end user and brings value to fleet operations. View the MyGeotab Product Guide here.",
    symbol: "My",
    group: 2,

    shells: [2, 8, 18, 18, 8, 2],

    electronAffinity: 13.954,
    electronegativityPauling: 0.89,
    ionizationEnergies: [502.9, 965.2, 3600],
    earthAbundance: 425,
  },
  {
    name: "Alternative Fuels",
    appearance: "silvery white",
    atomicMass: 138.905477,
    boil: 3737,
    category: "Sustainability",
    color: null,
    density: 6.162,
    discoveredBy: "Carl Gustaf Mosander",
    melt: 1193,
    molarHeat: 27.11,

    number: 57,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Lanthanum",

    summary:
      "Alternative fuels is a broad term used to encompass all non-gasoline and non-diesel engine technology. Alternative fuels include fuels such as propane, compressed natural gas (CNG), biodiesel, ethanol, and hydrogen fuel cells. It also includes electric vehicles (see separate glossary term for electric vehicles). With any of these technologies, using telematics can help not only figure out which fuel would be best suited for particular vehicles or applications but then it can help benchmark and track the benefits received by switching all or part of a fleet to alternative fuels.",
    symbol: "Af",
    group: 3,

    shells: [2, 8, 18, 18, 9, 2],

    electronAffinity: 53,
    electronegativityPauling: 1.1,
    ionizationEnergies: [538.1, 1067, 1850.3, 4819, 5940],
    earthAbundance: 39,
  },
  {
    name: "Battery Voltage",
    appearance: "silvery white",
    atomicMass: 140.1161,
    boil: 3716,
    category: "Sustainability",
    color: null,
    density: 6.77,
    discoveredBy: "Martin Heinrich Klaproth",
    melt: 1068,
    molarHeat: 26.94,

    number: 58,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Cerium",

    summary:
      "Battery voltage is one of the many items that can be tracked by a telematics system. By tracking battery voltage, you can better monitor vehicle health.",
    symbol: "Ba",
    group: 4,

    shells: [2, 8, 18, 19, 9, 2],

    electronAffinity: 55,
    electronegativityPauling: 1.12,
    ionizationEnergies: [534.4, 1050, 1949, 3547, 6325, 7490],
    earthAbundance: 66.5,
  },
  {
    name: "BEV",
    appearance: "grayish white",
    atomicMass: 140.907662,
    boil: 3403,
    category: "Sustainability",
    color: null,
    density: 6.77,
    discoveredBy: "Carl Auer von Welsbach",
    melt: 1208,
    molarHeat: 27.2,

    number: 59,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Praseodymium",

    summary:
      "A battery electric vehicle (BEV) is a fully electric vehicle that does not contain an internal combustion engine (ICE). Examples of BEVs include the Nissan Leaf and Chevrolet Bolt. Every BEV has a large onboard battery that powers all vehicle functions from driving mechanics to power windows. BEVs are separated into two categories: short range and long range. Short-range BEVs have a battery size of less than 50 kWh while long-range BEVs have a battery size of over 50 kwh. For more information on how companies are adopting EVs into their fleets, see our white paper, here.",
    symbol: "Bv",
    group: 5,

    shells: [2, 8, 18, 21, 8, 2],

    electronAffinity: 93,
    electronegativityPauling: 1.13,
    ionizationEnergies: [527, 1020, 2086, 3761, 5551],
    earthAbundance: 9.2,
  },
  {
    name: "EV (Electric Vehicle)",
    appearance: "silvery white",
    atomicMass: 144.2423,
    boil: 3347,
    category: "Sustainability",
    color: null,
    density: 7.01,
    discoveredBy: "Carl Auer von Welsbach",
    melt: 1297,
    molarHeat: 27.45,

    number: 60,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Neodymium",

    summary:
      "Electric vehicles (EV) are cars, trucks or other transportation vehicles that rely on full or partial battery power. There are several types of electric vehicles, including hybrid electric vehicles (HEV), battery electric vehicles (BEV) and plug-in hybrid vehicles (PHEV). Learn more about Geotab and EVs here.",
    symbol: "Ev",
    group: 6,

    shells: [2, 8, 18, 22, 8, 2],

    electronAffinity: 184.87,
    electronegativityPauling: 1.14,
    ionizationEnergies: [533.1, 1040, 2130, 3900],
    earthAbundance: 41.5,
  },
  {
    name: "EV Range",
    appearance: "metallic",
    atomicMass: 145,
    boil: 3273,
    category: "Sustainability",
    color: null,
    density: 7.26,
    discoveredBy: "Chien Shiung Wu",
    melt: 1315,
    molarHeat: null,

    number: 61,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Promethium",

    summary:
      "This is the amount of range that a vehicle can travel based on their electric battery charge. The amount of range that a vehicle has can depend on various amounts of driving factors including aggressive driving, up slope driving, air conditioner use or extra weight in the vehicle.",
    symbol: "Er",
    group: 7,

    shells: [2, 8, 18, 23, 8, 2],

    electronAffinity: 12.45,
    electronegativityPauling: 1.13,
    ionizationEnergies: [540, 1050, 2150, 3970],
    earthAbundance: 0.00000000000000002,
  },
  {
    name: "EVSA",
    appearance: "silvery white",
    atomicMass: 150.362,
    boil: 2173,
    category: "Sustainability",
    color: null,
    density: 7.52,
    discoveredBy: "Lecoq de Boisbaudran",
    melt: 1345,
    molarHeat: 29.54,

    number: 62,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Samarium",

    summary:
      "An Electric Vehicle Suitability Assessment (EVSA) is a proprietary customized, interactive tool from Geotab that provides EV make and model recommendations for fleets. The tool is powered by Geotab’s largest collected EV telematics dataset in the world and takes into consideration: EV availability in the local market, EV performance in extreme weather conditions, financials related to procuring the EVs and more.",
    symbol: "Ea",
    group: 8,

    shells: [2, 8, 18, 24, 8, 2],

    electronAffinity: 15.63,
    electronegativityPauling: 1.17,
    ionizationEnergies: [544.5, 1070, 2260, 3990],
    earthAbundance: 7.05,
  },
  {
    name: "EVSE",
    appearance: null,
    atomicMass: 151.9641,
    boil: 1802,
    category: "Sustainability",
    color: null,
    density: 5.264,
    discoveredBy: "Eugène-Anatole Demarçay",
    melt: 1099,
    molarHeat: 27.66,

    number: 63,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Europium",

    summary:
      "An electric vehicle supply equipment (EVSE) is the intermediary between a power source and the vehicle’s charging port. It is typically mounted on a wall or raised on a pedestal. Its role is to safely relay the alternating current (AC) power to the vehicle.",
    symbol: "Ee",
    group: 9,

    shells: [2, 8, 18, 25, 8, 2],

    electronAffinity: 11.2,
    electronegativityPauling: 1.2,
    ionizationEnergies: [547.1, 1085, 2404, 4120],
    earthAbundance: 2.0,
  },
  {
    name: "EVSP",
    appearance: "silvery white",
    atomicMass: 157.253,
    boil: 3273,
    category: "Sustainability",
    color: null,
    density: 7.9,
    discoveredBy: "Jean Charles Galissard de Marignac",
    melt: 1585,
    molarHeat: 37.03,

    number: 64,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Gadolinium",

    summary:
      "An electric vehicle service provider (EVSP) provides connectivity across a network of charging stations. Connecting to a central server, they manage the software, database and communication interfaces that enable operation of the station.",
    symbol: "Ep",
    group: 10,

    shells: [2, 8, 18, 25, 9, 2],

    electronAffinity: 13.22,
    electronegativityPauling: 1.2,
    ionizationEnergies: [593.4, 1170, 1990, 4250],
    earthAbundance: 6.2,
  },
  {
    name: "Fleet Electrification",
    appearance: "silvery white",
    atomicMass: 158.925352,
    boil: 3396,
    category: "Sustainability",
    color: null,
    density: 8.23,
    discoveredBy: "Carl Gustaf Mosander",
    melt: 1629,
    molarHeat: 28.91,

    number: 65,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Terbium",

    summary:
      "Fleet electrification refers to the switchover of fleets from internal combustion engines (ICE) to electric vehicles (EVs). Electrifying a fleet can help to maximize fleet efficiency and contribute to green initiatives within the transportation industry. For more information on fleet electrification, see our blog post here.",
    symbol: "Fe",
    group: 11,

    shells: [2, 8, 18, 27, 8, 2],

    electronAffinity: 112.4,
    electronegativityPauling: 1.1,
    ionizationEnergies: [565.8, 1110, 2114, 3839],
    earthAbundance: 1.2,
  },
  {
    name: "Green Fleet",
    appearance: "silvery white",
    atomicMass: 162.5001,
    boil: 2840,
    category: "Sustainability",
    color: null,
    density: 8.54,
    discoveredBy: "Lecoq de Boisbaudran",
    melt: 1680,
    molarHeat: 27.7,

    number: 66,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Dysprosium",

    summary:
      "“Green fleet” is a term used to reference fleets that are focused on sustainability, with goals to reduce environmental impact, through initiatives such as decreasing greenhouse gas emissions and fuel consumption, and electric vehicle adoption. See also: 30 tips for green fleets.",
    symbol: "Gf",
    group: 12,

    shells: [2, 8, 18, 28, 8, 2],

    electronAffinity: 33.96,
    electronegativityPauling: 1.22,
    ionizationEnergies: [573, 1130, 2200, 3990],
    earthAbundance: 5.2,
  },
  {
    name: "HEV",
    appearance: "silvery white",
    atomicMass: 164.930332,
    boil: 2873,
    category: "Sustainability",
    color: null,
    density: 8.79,
    discoveredBy: "Marc Delafontaine",
    melt: 1734,
    molarHeat: 27.15,

    number: 67,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Holmium",

    summary:
      "A hybrid electric vehicle (HEV) is a vehicle that contains both an onboard battery and an internal combustion engine (ICE). An example of an HEV is the Toyota Prius. HEVs contain small onboard batteries that are charged via regenerative braking and cannot be charged externally. The included battery is only used when idling or when the car begins moving from a stopped position. To learn more about the efficiency of HEVs, see our blog post here.",
    symbol: "Hv",
    group: 13,

    shells: [2, 8, 18, 29, 8, 2],

    electronAffinity: 32.61,
    electronegativityPauling: 1.23,
    ionizationEnergies: [581, 1140, 2204, 4100],
    earthAbundance: 1.3,
  },
  {
    name: "kWh Per Mile",
    appearance: "silvery white",
    atomicMass: 167.2593,
    boil: 3141,
    category: "Sustainability",
    color: null,
    density: 9.066,
    discoveredBy: "Carl Gustaf Mosander",
    melt: 1802,
    molarHeat: 28.12,

    number: 68,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Erbium",

    summary:
      "The kilowatt-hours per mile (kWh per mile) represents how much electricity an EV uses in one mile driven, indicating its fuel efficiency.",
    symbol: "Kh",
    group: 14,

    shells: [2, 8, 18, 30, 8, 2],

    electronAffinity: 30.1,
    electronegativityPauling: 1.24,
    ionizationEnergies: [589.3, 1150, 2194, 4120],
    earthAbundance: 3.5,
  },
  {
    name: "Maximum Range",
    appearance: "silvery gray",
    atomicMass: 168.934222,
    boil: 2223,
    category: "Sustainability",
    color: null,
    density: 9.32,
    discoveredBy: "Per Teodor Cleve",
    melt: 1818,
    molarHeat: 27.03,

    number: 69,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Thulium",

    summary:
      "The total number of miles an EV can be driven before it needs to stop and recharge. The maximum range is determined by a number of different factors including temperature, operating climate and vehicle age. The older a vehicle is, the more susceptible it is to battery degradation, which can lessen the maximum range over time.",
    symbol: "Mr",
    group: 15,

    shells: [2, 8, 18, 31, 8, 2],

    electronAffinity: 99,
    electronegativityPauling: 1.25,
    ionizationEnergies: [596.7, 1160, 2285, 4120],
    earthAbundance: 0.52,
  },
  {
    name: "MPGe",
    appearance: null,
    atomicMass: 173.0451,
    boil: 1469,
    category: "Sustainability",
    color: null,
    density: 6.9,
    discoveredBy: "Jean Charles Galissard de Marignac",
    melt: 1097,
    molarHeat: 26.74,

    number: 70,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Ytterbium",

    summary:
      "Miles per gallon of gasoline-equivalent (MPGe) is a metric used by the Environmental Protection Agency (EPA) to compare the fuel economy of EVs and other alternative fuel vehicles with gas-powered vehicles.",
    symbol: "Me",
    group: 16,

    shells: [2, 8, 18, 32, 8, 2],

    electronAffinity: -1.93,
    electronegativityPauling: 1.1,
    ionizationEnergies: [603.4, 1174.8, 2417, 4203],
    earthAbundance: 3.2,
  },
  {
    name: "PHEV",
    appearance: "silvery white",
    atomicMass: 174.96681,
    boil: 3675,
    category: "Sustainability",
    color: null,
    density: 9.841,
    discoveredBy: "Georges Urbain",
    melt: 1925,
    molarHeat: 26.86,

    number: 71,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Lutetium",

    summary:
      "A plug-in hybrid electric vehicle (PHEV) has a two-part drive system, including an electric drive and a small internal combustion engine running on fuel. The two main other types of EVs are hybrid electric vehicles (HEV) and battery electric vehicles (BEV).",
    symbol: "Pv",
    group: 17,

    shells: [2, 8, 18, 32, 9, 2],

    electronAffinity: 33.4,
    electronegativityPauling: 1.27,
    ionizationEnergies: [523.5, 1340, 2022.3, 4370, 6445],
    earthAbundance: 0.8,
  },
  {
    name: "Fleet Tracking",
    appearance: "steel gray",
    atomicMass: 178.492,
    boil: 4876,
    category: "General",
    color: null,
    density: 13.31,
    discoveredBy: "Dirk Coster",
    melt: 2506,
    molarHeat: 25.73,

    number: 72,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Hafnium",

    summary:
      "Fleet tracking is the use of a vehicle tracking device and software to monitor and manage a fleet of vehicles. Through fleet tracking, a fleet manager or business owner can collect data on location and vehicle health.",
    symbol: "Ft",
    group: 4,

    shells: [2, 8, 18, 32, 10, 2],

    electronAffinity: 17.18,
    electronegativityPauling: 1.3,
    ionizationEnergies: [658.5, 1440, 2250, 3216],
    earthAbundance: 3.0,
  },
  {
    name: "G-force",
    appearance: "gray blue",
    atomicMass: 180.947882,
    boil: 5731,
    category: "General",
    color: null,
    density: 16.69,
    discoveredBy: "Anders Gustaf Ekeberg",
    melt: 3290,
    molarHeat: 25.36,

    number: 73,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Tantalum",

    summary:
      "Measured by an accelerometer, G-force is the movement of the vehicle and acceleration, whether left/right, up/down, forward/back. This information helps fleets reconstruct accidents. Read all about G-force and how it helps understand dangerous driving behaviors here.",
    symbol: "Fo",
    group: 5,

    shells: [2, 8, 18, 32, 11, 2],

    electronAffinity: 31,
    electronegativityPauling: 1.5,
    ionizationEnergies: [761, 1500],
    earthAbundance: 2.0,
  },
  {
    name: "GAVDA",
    appearance: "grayish white, lustrous",
    atomicMass: 183.841,
    boil: 6203,
    category: "General",
    color: null,
    density: 19.25,
    discoveredBy: "Carl Wilhelm Scheele",
    melt: 3695,
    molarHeat: 24.27,

    number: 74,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Tungsten",

    summary:
      "GAVDA stands for the Global Alliance for Vehicle Data Access, a group that works to preserve and enhance the open, secure, technology-neutral and direct access by vehicle owners to real-time data.",
    symbol: "Gv",
    group: 6,

    shells: [2, 8, 18, 32, 12, 2],

    electronAffinity: 78.76,
    electronegativityPauling: 2.36,
    ionizationEnergies: [770, 1700],
    earthAbundance: 1.25,
  },
  {
    name: "GPS",
    appearance: "silvery-grayish",
    atomicMass: 186.2071,
    boil: 5869,
    category: "General",
    color: null,
    density: 21.02,
    discoveredBy: "Masataka Ogawa",
    melt: 3459,
    molarHeat: 25.48,

    number: 75,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Rhenium",

    summary:
      "GPS, or the global positioning system, is a navigation network of satellites, monitoring stations, and receivers used to transmit global location data. GPS is used in devices like cell phones and in-car navigation systems to help track location and provide directions from point A to point B.",
    symbol: "Gp",
    group: 7,

    shells: [2, 8, 18, 32, 13, 2],

    electronAffinity: 5.8273,
    electronegativityPauling: 1.9,
    ionizationEnergies: [760, 1260, 2510, 3640],
    earthAbundance: 0.0007,
  },
  {
    name: "Internal Combustion Engine",
    appearance: "silvery, blue cast",
    atomicMass: 190.233,
    boil: 5285,
    category: "General",
    color: null,
    density: 22.59,
    discoveredBy: "Smithson Tennant",
    melt: 3306,
    molarHeat: 24.7,

    number: 76,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Osmium",

    summary:
      "An internal combustion engine (ICE) is a traditional engine powered by gasoline, diesel, or organic material-based fuels. They are the most commonly used type of engine on the road, even with the rise of electric vehicles (EV). Vehicles that have an ICE generally require substantially more maintenance than EVs as they are made up of multiple moving parts that work to power the vehicle. ICEs are much more efficient now that when they were first invented, but are still nowhere near as efficient as EVs. For more information, see our blog on hybrid vs. conventional vehicles.",
    symbol: "Ic",
    group: 8,

    shells: [2, 8, 18, 32, 14, 2],

    electronAffinity: 103.99,
    electronegativityPauling: 2.2,
    ionizationEnergies: [840, 1600],
    earthAbundance: 0.0015,
  },
  {
    name: "IoT",
    appearance: "silvery white",
    atomicMass: 192.2173,
    boil: 4403,
    category: "General",
    color: null,
    density: 22.56,
    discoveredBy: "Smithson Tennant",
    melt: 2719,
    molarHeat: 25.1,

    number: 77,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Iridium",

    summary:
      "The Internet of Things (IoT) is the trend toward “smart” products, from smart products in your home such as refrigerators and lights, to products used in transportation such as smart traffic signals that can modify signal timing based on traffic flows throughout the day. Other examples of IoT in the automotive industry are car sharing companies, where a user can reserve, unlock and rent a vehicle through an app on their phone. Read here for more about how IoT is affecting the automotive industry.",
    symbol: "It",
    group: 9,

    shells: [2, 8, 18, 32, 15, 2],

    electronAffinity: 150.94,
    electronegativityPauling: 2.2,
    ionizationEnergies: [880, 1600],
    earthAbundance: 0.001,
  },
  {
    name: "J1939",
    appearance: "silvery white",
    atomicMass: 195.0849,
    boil: 4098,
    category: "General",
    color: null,
    density: 21.45,
    discoveredBy: "Antonio de Ulloa",
    melt: 2041.4,
    molarHeat: 25.86,

    number: 78,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Platinum",

    summary:
      "The J1939 standard was developed by SAE International to create consistency in how different components in a vehicle communicate with each other. The standard is used in conjunction with the controller area network bus (CAN bus) system for medium and heavy-duty commercial vehicles to send and receive signals within a vehicle. Included within J1939 is the digital annex (DA), which defines thousands of signals used on a CAN bus.",
    symbol: "J1",
    group: 10,

    shells: [2, 8, 18, 32, 17, 1],

    electronAffinity: 205.041,
    electronegativityPauling: 2.28,
    ionizationEnergies: [870, 1791],
    earthAbundance: 0.005,
  },
  {
    name: "Machine Learning",
    appearance: "metallic yellow",
    atomicMass: 196.9665695,
    boil: 3243,
    category: "General",
    color: null,
    density: 19.3,
    discoveredBy: "Middle East",
    melt: 1337.33,
    molarHeat: 25.418,

    number: 79,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Gold",

    summary:
      "Machine learning is what makes modern predictive modeling possible, meaning that through historical data, a computer/artificial intelligence can learn about what’s most likely to happen next. Machine learning is one aspect to autonomous vehicle technology that makes it more than just sensors and cameras. It can continue to learn more and more about the roads it travels on and use that for later trips when the vehicle is on that road again.",
    symbol: "Ml",
    group: 11,

    shells: [2, 8, 18, 32, 18, 1],

    electronAffinity: 222.747,
    electronegativityPauling: 2.54,
    ionizationEnergies: [890.1, 1980],
    earthAbundance: 0.004,
  },
  {
    name: "MPG",
    appearance: "silvery",
    atomicMass: 200.5923,
    boil: 629.88,
    category: "General",
    color: null,
    density: 13.534,
    discoveredBy: "unknown, before 2000 BCE",
    melt: 234.321,
    molarHeat: 27.983,

    number: 80,
    period: 6,
    phase: "Liquid",
    source: "https://en.wikipedia.org/wiki/Mercury (Element)",

    summary:
      "MPG (miles per gallon) refers to the distance (measured in miles) in which a vehicle travels, per gallon of fuel that is used.",
    symbol: "Mg",
    group: 12,

    shells: [2, 8, 18, 32, 18, 2],

    electronAffinity: -48,
    electronegativityPauling: 2,
    ionizationEnergies: [1007.1, 1810, 3300],
    earthAbundance: 0.085,
  },
  {
    name: "Distracted Driving",
    appearance: "silvery white",
    atomicMass: 204.38,
    boil: 1746,
    category: "Safety",
    color: null,
    density: 11.85,
    discoveredBy: "William Crookes",
    melt: 577,
    molarHeat: 26.32,

    number: 81,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Thallium",

    summary:
      "Distracted driving is a serious and dangerous offense, punishable by law in many countries, and can be defined as driving and using a phone or texting, eating, or another activity that takes a driver’s eyes off the road or hands off the wheel. Read more distracted driving facts.",
    symbol: "Dd",
    group: 13,

    shells: [2, 8, 18, 32, 18, 3],

    electronAffinity: 36.4,
    electronegativityPauling: 1.62,
    ionizationEnergies: [589.4, 1971, 2878],
    earthAbundance: 0.85,
  },
  {
    name: "Driver Coaching",
    appearance: "metallic gray",
    atomicMass: 207.21,
    boil: 2022,
    category: "Safety",
    color: null,
    density: 11.34,
    discoveredBy: "Middle East",
    melt: 600.61,
    molarHeat: 26.65,

    number: 82,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Lead_(element)",

    summary:
      "Driver coaching includes tools that can provide insight and training direction to drivers. Fleet managers can help ensure that their drivers are being safe on the roads, and includes features such as in-vehicle driver feedback and detection alerts for risky driving behaviours. Top driving behaviours can also be monitored to help managers identify their top performers.",
    symbol: "Dc",
    group: 14,

    shells: [2, 8, 18, 32, 18, 4],

    electronAffinity: 34.4204,
    electronegativityPauling: 1.87,
    ionizationEnergies: [715.6, 1450.5, 3081.5, 4083, 6640],
    earthAbundance: 14,
  },
  {
    name: "Driver Feedback",
    appearance: "lustrous silver",
    atomicMass: 208.980401,
    boil: 1837,
    category: "Safety",
    color: null,
    density: 9.78,
    discoveredBy: "Claude François Geoffroy",
    melt: 544.7,
    molarHeat: 25.52,

    number: 83,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Bismuth",

    summary:
      "Driver feedback refers to the use of technology to notify a driver of driving errors through audible beeps or spoken messages to help promote safety on the road. Feedback can be paired with driver management and training solutions to further improve behavior and help reduce collisions. See also: How to get driver buy-in on driver scorecards.",
    symbol: "Fb",
    group: 15,

    shells: [2, 8, 18, 32, 18, 5],

    electronAffinity: 90.924,
    electronegativityPauling: 2.02,
    ionizationEnergies: [703, 1610, 2466, 4370, 5400, 8520],
    earthAbundance: 0.0085,
  },
  {
    name: "Zones",
    appearance: "silvery",
    atomicMass: 209,
    boil: 1235,
    category: "Productivity",
    color: null,
    density: 9.196,
    discoveredBy: "Pierre Curie",
    melt: 527,
    molarHeat: 26.4,

    number: 84,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Polonium",

    summary:
      "Creating a zone is a key functionality in telematics software and allows fleet managers to track metrics on productivity, such as how long a truck was stopped at a customer location for a drop-off.",
    symbol: "Zn",
    group: 16,

    shells: [2, 8, 18, 32, 18, 6],

    electronAffinity: 136,
    electronegativityPauling: 2,
    ionizationEnergies: [812.1],
    earthAbundance: 0.0000000002,
  },
  {
    name: "Preventative Maintenance",
    appearance: "unknown, probably metallic",
    atomicMass: 210,
    boil: 610,
    category: "Fleet Optimization",
    color: null,
    density: 6.35,
    discoveredBy: "Dale R. Corson",
    melt: 575,
    molarHeat: null,

    number: 85,
    period: 6,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Astatine",

    summary:
      "Preventive maintenance is the scheduled maintenance to regularly check a vehicle for potential problems. Getting the oil changed is just one part of a preventive maintenance check. Other tasks include checking all fluid levels, brakes, tires, and so on. Telematics goes hand in hand with preventive maintenance because fleets can keep track of maintenance scheduling and even get alerts when the engine triggers a diagnostic trouble code, which means there could be something wrong with the vehicle. Fleet can then get the vehicle into the shop, while a technician can already diagnose the problem before the vehicle even gets there.",
    symbol: "Pm",
    group: 17,

    shells: [2, 8, 18, 32, 18, 7],

    electronAffinity: 233,
    electronegativityPauling: 2.2,
    ionizationEnergies: [899.003],
    earthAbundance: 0.00000000000000000003,
  },
  {
    name: "IFTA",
    appearance:
      "colorless gas, occasionally glows green or red in discharge tubes",
    atomicMass: 222,
    boil: 211.5,
    category: "Compliance",
    color: null,
    density: 9.73,
    discoveredBy: "Friedrich Ernst Dorn",
    melt: 202,
    molarHeat: null,

    number: 86,
    period: 6,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Radon",

    summary:
      "The International Fuel Tax Agreement (IFTA) is a fuel tax paid by interstate commercial carriers. The purpose is to use the funds to help keep U.S. and Canada highways funded and maintained. There are 48 American jurisdictions (states) and 10 Canadian jurisdictions (provinces) that are currently members of IFTA. Telematics can significantly help with IFTA compliance and reporting by tracking miles and fuel use.",
    symbol: "If",
    group: 18,

    shells: [2, 8, 18, 32, 18, 8],

    electronAffinity: -68,
    electronegativityPauling: 2.2,
    ionizationEnergies: [1037],
    earthAbundance: 0.0000000000004,
  },
  {
    name: "OEM",
    appearance: null,
    atomicMass: 223,
    boil: 950,
    category: "Hardware",
    color: null,
    density: 1.87,
    discoveredBy: "Marguerite Perey",
    melt: 300,
    molarHeat: null,

    number: 87,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Francium",

    summary:
      "The term “original equipment manufacturer,” abbreviated as “OEM,” refers to companies that produce cars and trucks and also those that manufacture parts and equipment for vehicles. For more information on how Geotab integrates with third-party information provided through built-in OEM devices, read this article.",
    symbol: "Oe",
    group: 1,

    shells: [2, 8, 18, 32, 18, 8, 1],

    electronAffinity: 46.89,
    electronegativityPauling: 0.79,
    ionizationEnergies: [380],
    earthAbundance: 0.000000000000000001,
  },
  {
    name: "Web-based",
    appearance: "silvery white metallic",
    atomicMass: 226,
    boil: 2010,
    category: "Software",
    color: null,
    density: 5.5,
    discoveredBy: "Pierre Curie",
    melt: 1233,
    molarHeat: null,

    number: 88,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Radium",

    summary:
      "Web-based software is software which is used over a web browser on the Internet. Web-based software generally does not require anything to be installed, downloaded or upgrading.",
    symbol: "Wb",
    group: 2,

    shells: [2, 8, 18, 32, 18, 8, 2],

    electronAffinity: 9.6485,
    electronegativityPauling: 0.9,
    ionizationEnergies: [509.3, 979],
    earthAbundance: 0.0000009,
  },
  {
    name: "Range Anxiety",
    appearance: null,
    atomicMass: 227,
    boil: 3500,
    category: "Sustainability",
    color: null,
    density: 10,
    discoveredBy: "Friedrich Oskar Giesel",
    melt: 1500,
    molarHeat: 27.2,

    number: 89,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Actinium",

    summary:
      "Range anxiety refers to an EV driver’s fear of running out of electricity before the end of a trip.",
    symbol: "Ra",
    group: 3,

    shells: [2, 8, 18, 32, 18, 9, 2],

    electronAffinity: 33.77,
    electronegativityPauling: 1.1,
    ionizationEnergies: [499, 1170],
    earthAbundance: 0.0000000000006,
  },
  {
    name: "SOC",
    appearance: "silvery, often with black tarnish",
    atomicMass: 232.03774,
    boil: 5061,
    category: "Sustainability",
    color: null,
    density: 11.724,
    discoveredBy: "Jöns Jakob Berzelius",
    melt: 2023,
    molarHeat: 26.23,

    number: 90,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Thorium",

    summary:
      "State of charge (SOC) refers to the amount of battery power left in an EV, as measured in percentage. Read here for more on how one UK fleet used Geotab devices to better track their SOC.",
    symbol: "So",
    group: 4,

    shells: [2, 8, 18, 32, 18, 10, 2],

    electronAffinity: 112.72,
    electronegativityPauling: 1.3,
    ionizationEnergies: [587, 1110, 1930, 2780],
    earthAbundance: 9.6,
  },
  {
    name: "Sustainability",
    appearance: "bright, silvery metallic luster",
    atomicMass: 231.035882,
    boil: 4300,
    category: "Sustainability",
    color: null,
    density: 15.37,
    discoveredBy: "William Crookes",
    melt: 1841,
    molarHeat: null,

    number: 91,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Protactinium",

    summary:
      "Sustainable fleet management is the practice of focusing and reducing environmental impact by making fleet enhancements and using management tools for fuel and CO2 emissions tracking, route optimization, as well as through electric vehicle adoption.",
    symbol: "Ss",
    group: 5,

    shells: [2, 8, 18, 32, 20, 9, 2],

    electronAffinity: 53.03,
    electronegativityPauling: 1.5,
    ionizationEnergies: [568],
    earthAbundance: 0.0000014,
  },
  {
    name: "ULEZ",
    appearance: null,
    atomicMass: 238.028913,
    boil: 4404,
    category: "Sustainability",
    color: null,
    density: 19.1,
    discoveredBy: "Martin Heinrich Klaproth",
    melt: 1405.3,
    molarHeat: 27.665,

    number: 92,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Uranium",

    summary:
      "The Ultra Low Emission Zone (ULEZ) is an area in Central London where drivers must pay a daily fee for driving within the zone. The initiative was put in place to improve air quality in this heavily populated area and encourage the use of more environmentally friendly vehicles. For more information on how the UK is encouraging green fleets, read this whitepaper.",
    symbol: "Uz",
    group: 6,

    shells: [2, 8, 18, 32, 21, 9, 2],

    electronAffinity: 50.94,
    electronegativityPauling: 1.38,
    ionizationEnergies: [597.6, 1420],
    earthAbundance: 2.7,
  },
  {
    name: "Zero-emissions",
    appearance: "silvery metallic",
    atomicMass: 237,
    boil: 4447,
    category: "Sustainability",
    color: null,
    density: 20.45,
    discoveredBy: "Edwin McMillan",
    melt: 912,
    molarHeat: 29.46,

    number: 93,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Neptunium",

    summary:
      "Zero-emissions refers to a global movement towards sustainability based on EVs generating lower or zero greenhouse gas emissions and use of other clean, sustainable technology. For more information on the road to zero-emissions, see here.",
    symbol: "Ze",
    group: 7,

    shells: [2, 8, 18, 32, 22, 9, 2],

    electronAffinity: 45.85,
    electronegativityPauling: 1.36,
    ionizationEnergies: [604.5],
    earthAbundance: 0.000000000003,
  },
  {
    name: "API",
    appearance: "silvery white, tarnishing to dark gray in air",
    atomicMass: 244,
    boil: 3505,
    category: "Expandability",
    color: null,
    density: 19.816,
    discoveredBy: "Glenn T. Seaborg",
    melt: 912.5,
    molarHeat: 35.5,

    number: 94,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Plutonium",

    summary:
      "APIs are essential for integration of fleet management systems. An API, or application programming interface, is the language a computer uses to tell the system what data to pull. These languages must be able to talk to each other for an integration to occur. A good example of a successful integration is also seeing temperature tracking information on reefer units in your telematics dashboard.",
    symbol: "Ap",
    group: 8,

    shells: [2, 8, 18, 32, 24, 8, 2],

    electronAffinity: -48.33,
    electronegativityPauling: 1.28,
    ionizationEnergies: [584.7],
    earthAbundance: 0.00000000003,
  },
  {
    name: "Expandability",
    appearance: "silvery white",
    atomicMass: 243,
    boil: 2880,
    category: "Expandability",
    color: null,
    density: 12,
    discoveredBy: "Glenn T. Seaborg",
    melt: 1449,
    molarHeat: 62.7,

    number: 95,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Americium",

    summary:
      "Expandability refers to technology that supports additional integrations with other software or hardware to extend capabilities. To learn about specific expandability options for Geotab, read about the Geotab OEM data platform, our Guide to Geotab IOX Add-Ons, or visit the Marketplace.",
    symbol: "Ex",
    group: 9,

    shells: [2, 8, 18, 32, 25, 8, 2],

    electronAffinity: 9.93,
    electronegativityPauling: 1.13,
    ionizationEnergies: [578],
    earthAbundance: null,
  },
  {
    name: "Hardware Integration",
    appearance: "silvery metallic, glows purple in the dark",
    atomicMass: 247,
    boil: 3383,
    category: "Expandability",
    color: null,
    density: 13.51,
    discoveredBy: "Glenn T. Seaborg",
    melt: 1613,
    molarHeat: null,

    number: 96,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Curium",

    summary:
      "This is where third-party hardware can integrate into one connected telematics platform. Vehicle data can all be consolidated through a single device.",
    symbol: "Hi",
    group: 10,

    shells: [2, 8, 18, 32, 25, 9, 2],

    electronAffinity: 27.17,
    electronegativityPauling: 1.28,
    ionizationEnergies: [581],
    earthAbundance: null,
  },
  {
    name: "Interoperability",
    appearance: "silvery",
    atomicMass: 247,
    boil: 2900,
    category: "Expandability",
    color: null,
    density: 14.78,
    discoveredBy: "Lawrence Berkeley National Laboratory",
    melt: 1259,
    molarHeat: null,

    number: 97,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Berkelium",

    summary:
      "The ability of systems to communicate and work with each other and make use of that information.",
    symbol: "Io",
    group: 11,

    shells: [2, 8, 18, 32, 27, 8, 2],

    electronAffinity: -165.24,
    electronegativityPauling: 1.3,
    ionizationEnergies: [601],
    earthAbundance: null,
  },
  {
    name: "IOX",
    appearance: "silvery",
    atomicMass: 251,
    boil: 1743,
    category: "Expandability",
    color: null,
    density: 15.1,
    discoveredBy: "Lawrence Berkeley National Laboratory",
    melt: 1173,
    molarHeat: null,

    number: 98,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Californium",

    summary:
      "IOX technology allows Geotab GO input/output device expansion. It allows you to connect other hardware to the device and further its capabilities using other Add-Ons. Geotab GO TALK is an example of IOX technology, in which the GO TALK device is connected into the Geotab GO device, sending driving tips and behavior alerts to the vehicle operator in real-time.",
    symbol: "Ox",
    group: 12,

    shells: [2, 8, 18, 32, 28, 8, 2],

    electronAffinity: -97.31,
    electronegativityPauling: 1.3,
    ionizationEnergies: [608],
    earthAbundance: null,
  },
  {
    name: "Marketplace",
    appearance: "silver-colored",
    atomicMass: 252,
    boil: 1269,
    category: "Expandability",
    color: null,
    density: 8.84,
    discoveredBy: "Lawrence Berkeley National Laboratory",
    melt: 1133,
    molarHeat: null,

    number: 99,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Einsteinium",

    summary:
      "The Geotab Marketplace is an online solutions center where fleets can browse for business-specific Add-Ons and software Add-Ins and Apps to integrate with their Geotab telematics system, such as a fuel tracker, driver scorecard or collision reconstruction. Read an overview of the Marketplace.",
    symbol: "Mp",
    group: 13,

    shells: [2, 8, 18, 32, 29, 8, 2],

    electronAffinity: -28.6,
    electronegativityPauling: 1.3,
    ionizationEnergies: [619],
    earthAbundance: null,
  },
  {
    name: "Open Platform",
    appearance: null,
    atomicMass: 257,
    boil: null,
    category: "Expandability",
    color: null,
    density: null,
    discoveredBy: "Lawrence Berkeley National Laboratory",
    melt: 1800,
    molarHeat: null,

    number: 100,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Fermium",

    summary:
      "Open platform means a proprietary telematics system which provides open or free access to the data through a software development kit (SDK) and application programming interfaces (APIs) — see separate glossary entries for both. In contrast, a closed platform may have vehicle manufacturer specific hardware and the access to data is limited or filtered. Open platform users have flexibility for integrating telematics with their other business systems, and using partner vendor devices, or third-party applications and solutions such as from the Geotab Marketplace. Find a longer definition of open platform in here and read about its advantages here.",
    symbol: "Op",
    group: 14,

    shells: [2, 8, 18, 32, 30, 8, 2],

    electronAffinity: 33.96,
    electronegativityPauling: 1.3,
    ionizationEnergies: [627],
    earthAbundance: null,
  },
  {
    name: "Scalability",
    appearance: null,
    atomicMass: 258,
    boil: null,
    category: "Expandability",
    color: null,
    density: null,
    discoveredBy: "Lawrence Berkeley National Laboratory",
    melt: 1100,
    molarHeat: null,

    number: 101,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Mendelevium",

    summary:
      "Scalability means being able to increase in size and strength as a business evolves and grows.",
    symbol: "Sa",
    group: 15,

    shells: [2, 8, 18, 32, 31, 8, 2],

    electronAffinity: 93.91,
    electronegativityPauling: 1.3,
    ionizationEnergies: [635],
    earthAbundance: null,
  },
  {
    name: "SDK",
    appearance: null,
    atomicMass: 259,
    boil: null,
    category: "Expandability",
    color: null,
    density: null,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: 1100,
    molarHeat: null,

    number: 102,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Nobelium",

    summary:
      "A software development kit (SDK) is the set of tools, information, and examples given to other software developers on how to work with the data. The SDK along with APIs (see separate glossary entry on APIs) enable what’s called open platform telematics (see separate entry). Learn why by watching a video about the Geotab SDK here.",
    symbol: "Sk",
    group: 16,

    shells: [2, 8, 18, 32, 32, 8, 2],

    electronAffinity: -223.22,
    electronegativityPauling: 1.3,
    ionizationEnergies: [642],
    earthAbundance: null,
  },
  {
    name: "Software Integration",
    appearance: null,
    atomicMass: 266,
    boil: null,
    category: "Expandability",
    color: null,
    density: null,
    discoveredBy: "Lawrence Berkeley National Laboratory",
    melt: 1900,
    molarHeat: null,

    number: 103,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Lawrencium",

    summary:
      "Software integration allows the leverage of real-time connected vehicle data feeds and the building of custom applications using Geotab’s aggregated data.",
    symbol: "Si",
    group: 17,

    shells: [2, 8, 18, 32, 32, 8, 3],

    electronAffinity: -30.04,
    electronegativityPauling: 1.3,
    ionizationEnergies: [470],
    earthAbundance: null,
  },
  {
    name: "NMFTA",
    appearance: null,
    atomicMass: 267,
    boil: 5800,
    category: "General",
    color: null,
    density: 23.2,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: 2400,
    molarHeat: null,

    number: 104,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Rutherfordium",

    summary:
      "The National Motor Freight Traffic Association (NMFTA) is a non-profit membership organization responsible for publishing National Motor Freight Classifications (NMFC) and assigning Standard Carrier Alpha codes (SCAC) and Standard Point Location codes (SPLC). The organization is comprised of inter and intrastate carriers as well as foreign commerce fleets. In 2019, the NMFTA released the Open Telematics API (OTAPI) which works to improve secure interoperability between telematics providers and fleets through data standardization.",
    symbol: "Nm",
    group: 4,

    shells: [2, 8, 18, 32, 32, 10, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [580],
    earthAbundance: null,
  },
  {
    name: "OTA",
    appearance: null,
    atomicMass: 268,
    boil: null,
    category: "General",
    color: null,
    density: 29.3,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: null,
    molarHeat: null,

    number: 105,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Dubnium",

    summary:
      "Over the Air (OTA) testing evaluates the performance of the integrated antenna on a telematics device (and many others) to understand the safety and risks behind using a particular type of device — consider all the safety labels seen on electronics in general. This particular test makes sure the device meets the minimum levels of radiation (total radiated power) and sensitivity (total isotropic power) and is only one of three main aspects of testing these types of devices. Read more here.",
    symbol: "Ot",
    group: 5,

    shells: [2, 8, 18, 32, 32, 11, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Secure Communication",
    appearance: null,
    atomicMass: 269,
    boil: null,
    category: "General",
    color: null,
    density: 35,
    discoveredBy: "Lawrence Berkeley National Laboratory",
    melt: null,
    molarHeat: null,

    number: 106,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Seaborgium",

    summary:
      "When there is a secure connection, it creates only communication between two (or the amount of authorized parties) without the risk of any third party interference. This ensures that unathorized access to telecommunications traffic doesn't occur.",
    symbol: "Sc",
    group: 6,

    shells: [2, 8, 18, 32, 32, 12, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Smart City",
    appearance: null,
    atomicMass: 270,
    boil: null,
    category: "General",
    color: null,
    density: 37.1,
    discoveredBy: "Gesellschaft für Schwerionenforschung",
    melt: null,
    molarHeat: null,

    number: 107,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Bohrium",

    summary:
      "Smart cities leverage connected infrastructure, sensors and IoT devices to help solve urban challenges like traffic congestion, service delivery for growing populations, and public health and safety. Telematics and urban analytics are the building blocks of smart cities, by providing municipalities with a real-time view on city operations and conditions. Learn more about smart city solutions from Geotab.",
    symbol: "Sm",
    group: 7,

    shells: [2, 8, 18, 32, 32, 13, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Telematics",
    appearance: null,
    atomicMass: 269,
    boil: null,
    category: "General",
    color: null,
    density: 40.7,
    discoveredBy: "Gesellschaft für Schwerionenforschung",
    melt: 126,
    molarHeat: null,

    number: 108,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Hassium",

    summary:
      "Telematics is the monitoring of a car, truck or another type of equipment or asset with a device to track GPS location, vehicle speed, driving behavior, and other engine data for fleet management and optimization. Go for a deeper dive in: What is telematics?",
    symbol: "Te",
    group: 8,

    shells: [2, 8, 18, 32, 32, 14, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Trips",
    appearance: null,
    atomicMass: 278,
    boil: null,
    category: "General",
    color: null,
    density: 37.4,
    discoveredBy: "Gesellschaft für Schwerionenforschung",
    melt: null,
    molarHeat: null,

    number: 109,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Meitnerium",

    summary:
      "Vehicle trips from point A to point B can be tracked by telematics and viewed from a fleet management software portal or app. In Geotab, a trip is defined when the vehicle starts moving to when the vehicle starts moving again after a stop (when the vehicle ignition is turned off, or when the vehicle has a speed of less than 1 km/h for more than 200 seconds).",
    symbol: "Tr",
    group: 9,

    shells: [2, 8, 18, 32, 32, 15, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Urban Analytics",
    appearance: null,
    atomicMass: 281,
    boil: null,
    category: "General",
    color: null,
    density: 34.8,
    discoveredBy: "Gesellschaft für Schwerionenforschung",
    melt: null,
    molarHeat: null,

    number: 110,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Darmstadtium",

    summary:
      "Urban analytics is the collection and analysis of data on smart city processes and environment. Hazardous driving areas, intersection metrics, areas of idling and hyper-local precipitation are examples of datasets that smart cities can use to support traffic optimization, and improve safety and the environment.",
    symbol: "Ur",
    group: 10,

    shells: [2, 8, 18, 32, 32, 16, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "VIN",
    appearance: null,
    atomicMass: 282,
    boil: null,
    category: "General",
    color: null,
    density: 28.7,
    discoveredBy: "Gesellschaft für Schwerionenforschung",
    melt: null,
    molarHeat: null,

    number: 111,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Roentgenium",

    summary:
      "The Vehicle Identification Number (VIN) assigned to every vehicle is what tracks the vehicle throughout its life, no matter who owns it. For large fleets, keeping track of these can be a pain. VINs are important since they can also tell you if there have been any recalls on the vehicle, for example. MyGeotab has a VIN lookup tool to help manage VINs.",
    symbol: "Vi",
    group: 11,

    shells: [2, 8, 18, 32, 32, 17, 2],

    electronAffinity: 151,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Watchdog Report",
    appearance: null,
    atomicMass: 285,
    boil: 3570,
    category: "General",
    color: null,
    density: 23.7,
    discoveredBy: "Gesellschaft für Schwerionenforschung",
    melt: null,
    molarHeat: null,

    number: 112,
    period: 7,
    phase: "Gas",
    source: "https://en.wikipedia.org/wiki/Copernicium",

    summary:
      "The Watchdog Report in MyGeotab tracks the status of all Geotab GO devices within your fleet and shows whether a device has been used recently, is installed correctly or is working properly. For more information on using the Watchdog Report to maintain a healthy fleet, see this blog post.",
    symbol: "Wr",
    group: 12,

    shells: [2, 8, 18, 32, 32, 18, 2],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Driver Scorecard",
    appearance: null,
    atomicMass: 286,
    boil: 1430,
    category: "Safety",
    color: null,
    density: 16,
    discoveredBy: "RIKEN",
    melt: 700,
    molarHeat: null,

    number: 113,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Ununtrium",

    summary:
      "A driver scorecard is a useful tool for fleet managers, to measure and rank driver performance, with the goal of improving safety, productivity, efficiency or even compliance. Fleets can customize scorecards to focus on speeding, harsh braking, engine light on, idling, fuel consumption, or other metrics.",
    symbol: "Ds",
    group: 13,

    shells: [2, 8, 18, 32, 32, 18, 3],

    electronAffinity: 66.6,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Drowsy Driving",
    appearance: null,
    atomicMass: 289,
    boil: 420,
    category: "Safety",
    color: null,
    density: 14,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: 340,
    molarHeat: null,

    number: 114,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Flerovium",

    summary:
      "Drowsy Driving, also called “fatigued driving,” increases the likelihood of crashing and causes many fatalities and injuries on roads each year. The National Safety Council reports that driving after more than 20 hours with no sleep is equal to driving with a 0.08% blood-alcohol concentration (U.S. legal limit).",
    symbol: "Dw",
    group: 14,

    shells: [2, 8, 18, 32, 32, 18, 4],

    electronAffinity: null,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Harsh Braking",
    appearance: null,
    atomicMass: 289,
    boil: 1400,
    category: "Safety",
    color: null,
    density: 13.5,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: 670,
    molarHeat: null,

    number: 115,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Ununpentium",

    summary:
      "Harsh braking occurs when a driver uses more force than necessary to stop the vehicle. The presence of harsh braking often indicates aggressive or distracted driving and can lead to costly claims, as well as increased maintenance issues.",
    symbol: "Hb",
    group: 15,

    shells: [2, 8, 18, 32, 32, 18, 5],

    electronAffinity: 35.3,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Seat Belt Usage",
    appearance: null,
    atomicMass: 293,
    boil: 1085,
    category: "Safety",
    color: null,
    density: 12.9,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: 709,
    molarHeat: null,

    number: 116,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Livermorium",

    summary:
      "Seat belt usage can actually be tracked by a telematics system such as the Geotab seat belt report, which lets managers know which drivers aren’t using their seat belt. It can also be used as part of the Geotab GO TALK in-vehicle coaching add-on (see separate glossary entry).",
    symbol: "Sb",
    group: 16,

    shells: [2, 8, 18, 32, 32, 18, 6],

    electronAffinity: 74.9,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Remote Diagnostics",
    appearance: null,
    atomicMass: 294,
    boil: 883,
    category: "Fleet Optimization",
    color: null,
    density: 7.17,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: 723,
    molarHeat: null,

    number: 117,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Tennessine",

    summary:
      "Remote diagnostics is a solution that fleets can use to set up automatic alerts on diagnostic trouble codes (DTCs) generated by the engine’s computer, along with severity, fault description, and recommendations for action. Benefits of remote diagnostics include helping prepare technicians in advance so they have the right parts and decreasing vehicle downtime.",
    symbol: "Rd",
    group: 17,

    shells: [2, 8, 18, 32, 32, 18, 7],

    electronAffinity: 165.9,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Tachograph",
    appearance: null,
    atomicMass: 294,
    boil: 350,
    category: "Compliance",
    color: null,
    density: 4.95,
    discoveredBy: "Joint Institute for Nuclear Research",
    melt: null,
    molarHeat: null,

    number: 118,
    period: 7,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Oganesson",

    summary:
      "A tachograph is a device affixed to a vehicle weighing at least 3.5 tonnes that automatically records data on speed and distance together with the driver's activity selected from a choice of modes. To learn more about driving hour regulations in Europe see, EU-regulation (EC) No 561/2006.",
    symbol: "Tg",
    group: 18,

    shells: [2, 8, 18, 32, 32, 18, 8],

    electronAffinity: 5.40318,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
  {
    name: "Ununennium",
    appearance: null,
    atomicMass: 315,
    boil: 630,
    category: "predicted to be an alkali metal",
    color: null,
    density: 3,
    discoveredBy: "GSI Helmholtz Centre for Heavy Ion Research",
    melt: null,
    molarHeat: null,

    number: 119,
    period: 8,
    phase: "Solid",
    source: "https://en.wikipedia.org/wiki/Ununennium",

    summary:
      "Ununennium, also known as eka-francium or simply element 119, is the hypothetical chemical element with symbol Uue and atomic number 119. Ununennium and Uue are the temporary systematic IUPAC name and symbol respectively, until a permanent name is decided upon. In the periodic table of the elements, it is expected to be an s-block element, an alkali metal, and the first element in the eighth period.",
    symbol: "Uue",
    group: 1,

    shells: [2, 8, 18, 32, 32, 18, 8, 1],

    electronAffinity: 63.87,
    electronegativityPauling: null,
    ionizationEnergies: [],
    earthAbundance: null,
  },
];

let groups: (number | null)[] = [];
let periods: (number | null)[] = [];
let atomicMasses: (number | null)[] = [];
let electronegativities: (number | null)[] = [];
let ionizationEnergies: (number | null)[] = [];
let meltingPoints: (number | null)[] = [];
let boilingPoints: (number | null)[] = [];
let molarHeats: (number | null)[] = [];
let densities: (number | null)[] = [];
let earthAbundance: (number | null)[] = [];

for (const atom of data) {
  groups.push(atom.group);
  periods.push(atom.period);
  atomicMasses.push(atom.atomicMass);
  electronegativities.push(atom.electronegativityPauling);
  ionizationEnergies.push(atom.ionizationEnergies[0] || null);
  meltingPoints.push(atom.melt);
  boilingPoints.push(atom.boil);
  molarHeats.push(atom.molarHeat);
  densities.push(atom.density);

  if (atom.earthAbundance === null) earthAbundance.push(null);
  else
    earthAbundance.push(Math.log10(Math.max(atom.earthAbundance, 0.00001)) + 5);
}

export const properties = [
  { name: "Group", value: groups },
  { name: "Period", value: periods },
  { name: "Atomic mass", value: atomicMasses },
  { name: "Density", value: densities },
  { name: "Electronegativity (Pauling)", value: electronegativities },
  { name: "First ionization energy", value: ionizationEnergies },
  { name: "Melting point", value: meltingPoints },
  { name: "Boiling point", value: boilingPoints },
  { name: "Molar heat capacity", value: molarHeats },
  { name: "Abundance in Earth's crust (Log scale)", value: earthAbundance },
];

export default data;
